import { PRINCIPAL_ROUTE_NAME } from "@router/principal";

const sv = {
  errorBoundary: {
    title: "Något gick fel",
    description:
      "Ett oväntat fel uppstod. Vänligen försök att uppdatera sidan eller kontakta support om problemet kvarstår.",
  },
  common: {
    preview: "Förhandsgranska",
    actions: "Åtgärder",
    noAnswer: "Inget svar",
    continue: "Fortsätt",
    next: "Nästa",
    previous: "Tidigare",
    complete: "Klar",
    skip: "Hoppa över",
    saveChanges: "Spara ändringar",
    save: "Spara",
    saveAndExit: "Spara & avsluta",
    autoSave: "Automatisk sparning",
    autosaveTemplateName: "Automatiskt sparad mall",
    templateTitleRequired: "Ange en titel för mallen",
    saveConfirmation: {
      title: "Spara ändringar",
      body: "Hur vill du spara dina ändringar?",
    },
    upload: "Ladda upp",
    uploadVideo: "Ladda upp video",
    loading: "Laddar",
    savedSuccessfully: "Sparades framgångsrikt.",
    errorOccurred: "Något gick fel. Försök igen.",
    back: "Tillbaka",
    cancel: "Avbryt",
    delete: "Ta bort",
    close: "Stäng",
    twentyMinutes: "20 min",
    fiftyMinutes: "50 min",
    resetPasswordError: "Ett fel uppstod när lösenordet skulle återställas",
    notFoundEmailError: "En användare med denna e-postadress kunde inte hittas",
    email: "E-postadress",
    password: "Lösenord",
    passwordConfirm: "Bekräfta ditt lösenord",
    corporateEmail: "Ange din skol- eller organisationsmail",
    anyEmail: "Ange din e-postadress",
    today: "Idag",
    scheduleSession: "Boka ett elevhälsosamtal",
    instantVideo: "Spontant samtal",
    invalidEmail: "Ogiltig e-postadress",
    invalidDate: "Ange ett giltigt datum.",
    invalidPasswordLength: "8 tecken långt",
    invalidPasswordMatch: "En stor bokstav, en liten bokstav & en siffra",
    invalidPasswordConfirm: "Lösenorden matchar inte",
    requiredField: "Detta fält är obligatoriskt",
    errorOccurred: "Något gick fel. Försök igen.",
    no: "Nej",
    checkSearch: "Lägg till en ny eller kontrollera om sökningen är korrekt",
    noFound: "Inga {{name}} hittades",
    switchAccountError: "Ett fel inträffade när du försökte byta organisation",
    dragNDrop:
      "Dra och släpp några filer hit, eller klicka för att välj filer.",
    continueWithCode: "Fortsätt med kod",
    continueWithoutCode: "Hoppa över",
    areYouSure: "Är du säker?",
    yes: "Ja",
    create: "Skapa",
    continue: "Fortsätt",
    keywordSearch: "Sök",
    filteredBy: "Filtrerat efter",
    selectAll: "Alla",
    none: "Ingen",
    matchAll: "och",
    matchAny: "eller",
    itemsSelected: "{0} valda",
    watchHelloVideo: "Se videohälsning",
    helloVideoTitle: "Videohälsning",
    profileImage: "Profilbild",
    aboutMeVideo: "Videohälsning",
    notes: "Anteckningar",
    noAvailableOptions: "Inga tillgängliga alternativ",
    noRecordsFound: "Inga poster hittades",
    noRecordsFoundSubtitle:
      "Försök justera din sökning eller dina filter för att hitta det du letar efter.",
    notEligibleToChange: "Inte berättigad att ändra",
    notEligibleToSendEmail: "Inte berättigad att skicka e-post",
    notEligibleToDeleteUser: "Inte berättigad att ta bort användare",
    notEligibleToDeactivateUser: "Inte berättigad att inaktivera användare",
    notEligibleToChangeAttribute: "Inte berättigad att ändra attribut",
    add: "Lägg till",
    color: "Färg",
    colorOptions: {
      red: "Röd",
      yellow: "Gul",
      green: "Grön",
      normal: "Normal",
    },
    min: "min",
    done: "Klart",
    send: "Skicka",
    selectStatus: "Välj en status",
    showMore: "Visa mer",
    showLess: "Visa mindre",
    download: "Ladda ner",
    downloadExcel: "Ladda ner EXCEL",
    downloadPdf: "Ladda ner PDF",
    downloadQrAsSvg: "Klicka och ladda ner QR som SVG",
    copied: "Kopierad",
    copyError: "Kunde inte kopiera",
    ok: "Okej",
    updateAvailable: "Uppdatering tillgänglig",
    updateAvailableDescription:
      "En uppdatering av Allbry finns tillgänglig. Uppdatera sidan för att få den senaste versionen.",
    refresh: "Uppdatera",
    copyToClipboard: "Kopiera till urklipp",
    copy: "Kopierat",
    backNavigationMessage:
      "Är du säker på att du vill gå tillbaka? Om du går tillbaka kommer dina ändringar att förloras.",
    yesBack: "Ja, gå tillbaka",
    saveAndGoBackMessage: "Är du säker på att du vill spara och gå tillbaka?",
    saveAndGoBack: "Ja, spara och gå tillbaka",
    unsavedChangesMessage:
      "Du har osparade ändringar. Vill du spara dem innan du går tillbaka?",
    saveAndGoBackButton: "Spara & gå tillbaka",
    discard: "Ignorera",
    goToAccountConfirmMessage:
      "Är du säker på att du vill byta till {{name}}? Om du fortsätter kommer eventuella osparade ändringar att förloras.",
    yesSwitch: "Ja, byt",
    current: "Nuvarande",
    system: "System",
    manual: "Manuell",
    downloadPDF: "Ladda ner PDF",
  },
  process: {
    title: "Processer",
    all: "Alla processer",
    active: "Aktiva processer",
    completed: "Avslutade processer",
    pending: "Väntande processer",
    create: "Skapa process",
    search: "Sök processer...",
    noProcesses: "Inga processer ännu",
    noProcessesSubtitle:
      "Skapa och hantera strukturerade processer för att följa elevers framsteg, uppgifter och milstolpar på ett ställe.",
    noProcessesCta: "Skapa din första process",
    sortBy: "Sortera efter",
    sortByStudent: "Elev",
    sortByProcessType: "Processtyp",
    sortByStartedDate: "Startdatum",
    sortByNextTask: "Nästa uppgiftsdatum",
    sortByEndDate: "Slutdatum",
    sortByStudents: "Antal elever",
    sortByStudentName: "Elevnamn",
    sortByTaskName: "Uppgiftsnamn",
    sortByProcessName: "Processnamn",
    searchPlaceholder: "Sök efter elev, uppgift eller processnamn...",
    chooseStudentsTitle: "Vilka elever vill du lägga till?",
    nextTask: "Nästa uppgift",
    started: "Startad",
    late: "Försenad",
    upcomingSoon: "Kommande",
    studentsCount_one: "{{count}} elev",
    studentsCount_other: "{{count}} elever",
    studentsTab: "Elever",
    attributesTab: "Attribut",
    ownedByMe: "Ägs av mig",
    studentCases: "Studentfall",
    programs: "Program",
    investigations: "Utredningar",
    taskDeadline: "Uppgiftens deadline",
    viaAttribute: "Via attribut",
    createdFromAttribute: "Denna process skapades från ett attribut",

    tabs: {
      overview: "Översikt",
      events: "Händelser",
      information: "Information",
    },
    tasks: "Uppgifter",
    attachments: "Bilagor",
    processTimeline: "Utredningsprocess",
    done: "Klar",
    cancelled: "Avbruten",
    skipped: "Överhoppad",
    bookNow: "Boka nu",
    consentRequired: "Medgivande krävs",
    currentStep: "Aktuellt steg",
    createNow: "Skapa nu",
    registerScreening: "Registrera screening",
    registerMeasurement: "Registrera mätning",
    createReferral: "Skapa remiss",
    skipTask: "Hoppa över",
    requireSkipWarning:
      "Detta steg är obligatoriskt för den här processen. Om du hoppar över det kommer du inte att kunna fylla i informationen för det här steget.",
    skipTaskConfirm:
      "Är du säker på att du vill hoppa över det här steget? Om du hoppar över det kommer du inte att kunna fylla i informationen för det här steget.",
    completeTaskConfirm:
      "Är du säker på att du har granskat relevant information? Detta kan inkludera varningar i studentprofilen eller olästa chattmeddelanden.",
    export: "Exportera",
    addReport: "Lägg till rapport",
    processName: "Process",
    student: "Elev",
    noTasks: "Inga avslutade uppgifter",
    noTasksHint: "Avslutade uppgifter från den här processen visas här",
    noAttachments: "Inga bilagor",
    noAttachmentsHint: "Uppladdade filer och dokument visas här",
    info: {
      overviewSection: "Översikt",
      studentsSection: "Elever",
      progressSection: "Framsteg",
      stepsSection: "Processsteg",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      journal: "Journal",
      reason: "Anledning",
      noReason: "Ingen anledning angiven",
      notSet: "Ej angett",
      totalTasks: "Totalt antal uppgifter",
      tasksHandled: "Uppgifter hanterade",
      completedTasks: "Avslutade",
      skippedTasks: "Överhoppade",
      remainingTasks: "Återstående",
      access: "Åtkomst",
    },
    noEvents: "Inga händelser ännu",
    noEventsHint:
      "Händelser från den här processen visas här när uppgifter påbörjas eller avslutas",
    eventActor: "Av {{name}}",
    eventSingular: "händelse",
    eventPlural: "händelser",
    pdf: {
      exported: "Exporterad",
      status: "Status",
      taskName: "Uppgift",
      taskType: "Typ",
      taskDate: "Datum",
      taskBy: "Av",
      eventDate: "Datum & tid",
      eventType: "Händelse",
      eventTask: "Uppgift",
      eventBy: "Av",
      attachmentName: "Filnamn",
      attachmentDescription: "Beskrivning",
      attachmentDate: "Uppladdad",
      attachmentBy: "Av",
      attachmentView: "Visa",
      studentName: "Namn",
      studentEmail: "E-post",
      studentGender: "Kön",
      studentExternalId: "Externt ID",
      studentAttribute: "Attribut",
    },
    taskTypes: {
      appointment: "Samtal",
      customReport: "Anpassad rapport",
      note: "Anteckning",
      reminder: "Påminnelse",
      survey: "Enkät",
      consent: "Medgivande",
      manual: "Manuell",
      custom: "Anpassad",
      information: "Information",
      visionScreening: "Synscreening",
      hearingScreening: "Hörselscreening",
      growthMeasurement: "Tillväxtmätning",
      referral: "Remiss",
    },
    statusValues: {
      active: "Aktiv",
      completed: "Avslutad",
      cancelled: "Avbruten",
    },

    stepper: {
      step1: "Kategori",
      step2: "Mall",
      step3: "Elever / Attribut",
      step4: "Journal",
      step5: "Sekretess",
      step6: "Granska",
    },
    step1: {
      title: "Ärendetyp",
      subtitle: "Välj vilken typ av process du vill starta",
    },
    step2: {
      noTemplates: "Inga mallar tillgängliga för den här kategorin",
      noAccess:
        "Du har inte behörighet att skapa den här processen.Vänligen begär journalåtkomst.",
      subtitle: "Välj en mall som passar dina behov",
    },
    step3: {
      title: "Elever / Attribut",
      subtitle:
        "Lägg till elever direkt, eller filtrera via ett gemensamt attribut",
      studentsSection: "Elever",
      attributesSection: "Attribut",
      addStudents: "Lägg till elever",
      addStudentsHint: "Klicka för att söka och välja elever",
      editStudents: "Redigera val",
      addAttributes: "Lägg till via attribut",
      addAttributesHint: "Filtrera elever med ett gemensamt attribut",
      editAttributes: "Redigera val",
      noAttributes: "Inga attribut hittades",
      selectedAttributes: "Valda attribut",
      noAttributesSelected: "Inga attribut valda",
      statsUniqueViaAttributes: "Unika elever från attribut",
      statsSharedAcrossAttributes: "Matchar flera attribut",
      statsAlreadySelectedManually: "Redan valda manuellt",
      statsAlsoMatchedByAttributes: "Matchar även valda attribut",
      statsTotalUnique: "Totalt unika elever",
      statsEstimatedMatches: "Uppskattade träffar",
      statsEstimatedMatchesSummary_one:
        "Cirka {{count}} elev matchar före borttagning av överlapp",
      statsEstimatedMatchesSummary_other:
        "Cirka {{count}} elever matchar före borttagning av överlapp",
      summaryTitle: "Processöversikt",
      summaryTargetStudents_one: "Den här processen skapas för {{count}} elev",
      summaryTargetStudents_other:
        "Den här processen skapas för {{count}} elever",
      summaryTargetStudentsEmpty:
        "Välj elever eller attribut för att se det slutliga antalet",
      summarySelectedManually: "Valda manuellt",
      summaryMatchedByAttributes: "Matchade via attribut",
      summaryOverlapRemoved: "Överlapp borttaget",
      summaryFinalStudents: "Slutligt antal elever",
      statsAttributes: "attribut",
      statsAttributesPlural: "attribut",
    },
    step4: {
      title: "Välj journal",
      subtitle: "Välj journaltyp för dokumentation",
    },
    step5: {
      title: "Sekretessinställningar",
      subtitle: "Kontrollera vem som kan se den här processen.",
      publicLabel: "Synlig för personal med tillgång till journal",
      publicDescription:
        "Alla rådgivare med åtkomst till vald journaltyp kan se och hantera den här processen. Tryck på knappen till höger om du endast vill att enstaka personer ska få tillgång till processen.",
      privateLabel: "Privat process",
      privateDescription:
        "Endast du och de rådgivare du väljer nedan kommer att ha åtkomst.",
      makePrivate: "Gör den här processen privat",
      accessTitle: "Vem har åtkomst",
      searchCounsellors: "Sök rådgivare...",
      noCounsellors: "Inga rådgivare hittades.",
      youOwner: "Du (ägare)",
      summaryPublic: "Synlig för journalrådgivare",
      summaryPrivate: "Privat — du + {{count}} rådgivare",
      summaryPrivateOnlyYou: "Privat — bara du",
    },
    step6: {
      defaultTemplateName: "Processmall",
      reviewTitle: "Granska & Bekräfta",
      reviewSubtitle: "Kontrollera dina val innan du skapar processen",
      summaryCategory: "Kategori",
      summaryTemplate: "Mall",
      summaryStudents: "Elever",
      summaryJournal: "Journal",
      summaryAccess: "Åtkomst",
      targetingTitle: "Berörda elever",
      reasonLabel: "Anledning till processen",
      reasonPlaceholder: "Beskriv anledningen till att starta denna process...",
      processTimeline: "Följ dessa steg",
      noSteps: "Inga steg tillgängliga för den här mallen",
      addStep: "Lägg till steg",
      finalStep: "Sista steg",
      required: "Obligatoriskt",
      dueInDays: "Förfaller om {{days}} dagar",
      attachConfig: "Bifoga rapport",
      selectConfig: "Välj en rapportkonfiguration",
      searchConfigs: "Sök konfigurationer...",
      noConfigs: "Inga konfigurationer hittades",
      createConfig: "Skapa konfiguration",
    },
    errors: {
      categoryRequired: "Kategori är obligatorisk",
      templateRequired: "Mall är obligatorisk",
      studentsRequired: "Minst en elev krävs",
      journalTypeRequired: "Journaltyp är obligatorisk",
      reasonRequired: "Anledning är obligatorisk",
      fetchTemplatesFailed: "Det gick inte att hämta mallar",
      createFailed: "Det gick inte att skapa processen",
    },
    bulk: {
      viewBulk: "Visa samlad vy",
      caseCount_one: "{{count}} ärende",
      caseCount_other: "{{count}} ärenden",
      sortAscending: "stigande ordning",
      stepPrefix: "Steg {{number}}: {{name}}",
      overallProgress: "Total framsteg",
      stepsCompleted: "{{done}}/{{total}} steg klara",
      showAll: "Visa alla {{count}} →",
      addStep: "Lägg till steg",
      notCompleted: "Ej genomförd",
      overlayCompleted: "{{done}}/{{total}} genomförda",
      sendReminder: "Skicka påminnelse",
      summary: "Sammanfattning",
      note: "Anteckning",
      doneCount: "{{count}} klara",
      remainingCount: "{{count}} kvar",
      notStartedCount: "{{count}} ej påbörjat",
      stepsHeading: "Steg",
      taskCompleted: "Uppgift genomförd",
      taskSkipped: "Uppgift överhoppad",
      taskNotCompleted:
        "Denna uppgift är ännu inte genomförd för den här eleven.",
      viewProfile: "Visa elevprofil",
      viewReferralDetails: "Visa remissdetaljer",
      viewProcessDetail: "Visa processdetalj",
      due: "Förfaller",
      overdue: "Försenad",
      dueSoon: "Förfaller snart",
      upcoming: "Kommande",
      completed: "Genomförd",
      studentCount_one: "{{count}} elev",
      studentCount_other: "{{count}} elever",
      tasksDoneOf: "{{done}}/{{total}} uppgifter klara",
      exportTitle: "Samlad processexport",
      stepsOverview: "Stegöversikt",
      studentCasesTable: "Elevärenden",
      stepProgress: "{{done}} / {{total}} klara",
      attributesSection: "Attribut",
      noAttributes: "Inga attribut",
      pdfDoneTotal: "Klara / Totalt",
      pdfProgress: "Framsteg",
      pdfCurrentStep: "Nuvarande steg",
      customTasks: "Anpassade uppgifter",
    },
  },
  modal: {
    sizeLimit: {
      title: "Gränsen för filstorlek har nåtts",
      content:
        "Filen är för stor för uppladdning, gränsen är {{sizeLimit}}. Var vänlig välj en annan.",
    },
    fileType: {
      title: "Ogiltig filtyp",
      content: "Du kan bara använda bilder",
    },
    akkImage: {
      akkImage: "Bildstöd",
      customImage: "Egen bild",
      uploadImage: "Välj bild",
    },
    endDate: {
      title: "Slutdatum",
      content: "Välj slutdatum",
    },
  },
  mobile: {
    notAvailable: "Webbversionen av Allbry är inte tillgänglig på mobilen",
    availableInLandscape:
      "Allbry-webbversionen är endast tillgänglig i liggande läge",
    pleaseUseLinks: "Ladda ner vår mobilapp via länken nedan",
    pleaseUseLinksLandscape:
      "Du kan ladda ner vår mobilapp genom att använda länken nedan",
    appStore: "App Store",
    googlePlay: "Google Play",
  },
  navigationGuide: {
    title: "Snabbguide",
    step: "Steg {{current}} av {{total}}",
    profileMenu: "Profilmeny",
    availability: "Onlinestatus",
    defaultDescription:
      "Öppna {{title}} från den här menyn för att använda funktionerna.",
    descriptions: {
      appointments: "Se dina bokade möten och boka ett nytt möte här.",
      messages:
        "Läs och skicka meddelanden för att hålla kontakten och få stöd.",
      checkInsAndSurveys:
        "Fyll i dina check-ins och enkäter och se dina svar här.",
      students:
        "Hitta elever och öppna deras profiler, meddelanden och stödinformation.",
      users: "Se och hantera användare och deras information.",
      reports: "Se och hantera rapporter här.",
      customReports: "Skapa och hantera rapportmallar och rapporter.",
      statistics: "Se statistik och följ upp aktivitet och resultat.",
      emailStatistics: "Se statistik och resultat för e-postutskick.",
      organization: "Se och hantera din organisation.",
      organizations: "Se och hantera organisationer.",
      counsellors: "Hitta elevhälsopersonal och se deras profiler.",
      config: "Skapa och hantera mallar för check-ins och enkäter.",
      process: "Skapa och följ stödprocesser och deras aktiviteter.",
      broadcastMessages: "Skicka meddelanden till flera mottagare.",
      dataMigration: "Importera och hantera organisationsdata.",
      ftpDataCollection: "Hantera data som samlas in via FTP.",
      configForm: "Konfigurera formulär och deras fält.",
      superActions: "Öppna administrativa verktyg och åtgärder.",
      profileMenu:
        "Välj din profilikon för att öppna din profil, inställningar och kontoalternativ.",
      availability: "Växla din status mellan online och offline.",
      profile:
        "Se din profil och uppdatera dina personuppgifter och din profilbild.",
      notifications: "Se dina notifikationer och olästa uppdateringar.",
      settings: "Hantera dina preferenser och kontoinställningar.",
      logOut: "Välj det här alternativet när du vill logga ut från Allbry.",
    },
  },
  introduction: {
    getSupport: "Elevhälsa direkt på webben",
    chat: {
      student: "Aden",
      counsellor: "Alexandra",
      messages: {
        first: "Hej!",
        second: "Jag känner mig nere",
        third: "Och har ingen att prata med... 😔",
        fourth:
          "Tja Aden! Du har ju mig att prata med! Berätta för mig, varför känner du dig nere?",
      },
    },
  },
  auth: {
    login: {
      withEmail: "Ange din e-postadress",
      enterPassword: "Ange ditt lösenord",
      codeStepTitle: "Har du fått en registreringskod?",
      loginSuccess: "Du har loggat in framgångsrikt",
      codeStepSubtitle:
        "I vissa fall behöver du en registreringskod för att registrera dig. Om du har fått en, vänligen ange den nedan. Om inte, tryck bara på hoppa över.",
      codeInput: "Registreringskod",
      codeInputHint: "Vänligen ange din registreringskod om du fått en",
      createPass: "Skapa ditt lösenord",
      terms: "Jag har läst, förstått och godkänner härmed Allbrys",
      termsLink: "villkor",
      paymentTitle: "Förnya din prenumeration",
      paymentDescription:
        "Allbry kostar {{price}} {{currency}} varje månad. Abonnemanget är aktivt tills du säger upp det.",
      rememberMe: "Kom ihåg mig",
    },
    logout: {
      logoutSuccess: "Du har loggat ut framgångsrikt",
    },
    signUpConsumer: {
      terms: "Jag har läst, förstått och godkänner härmed Allbrys ",
      termsLink: "villkor",
      startJourney: "Påbörja din resa med Allbry idag",
      withOrganization: "Registrera dig med ett organisationskonto (SSO)",
      withEmail: "Skapa konto",
      signUp: "Registrera dig med e-postadress",
      createPass: "Skapa lösenord",
      haveAccount: "Har du redan ett konto?",
      logIn: "Logga in",
      connectedOrganization: "Ditt konto tillhör ",
      aboutYourSelfHeader: "Välj användarnamn",
      aboutYourSelfDescription1:
        "Välj det namn du vill ska synas för kuratorn eller rådgivaren.",
      aboutYourSelfDescription2:
        "Vi lämnar inte ut din personliga information till tredje part.",
      paymentTitle: "Skapa abonnemang",
      paymentDescription:
        "Allbry kostar {{price}} kr per månad och du debiteras månadsvis i efterhand så länge du har ditt konto hos oss. Snabbt och enkelt, utan bindningstid.",
      paymentDescriptionSuccess:
        "Grattis! Ditt konto är nu skapat och abonnemanget är aktivt tills att du avbryter det.",
      successTitle: "Grattis!",
      successDescription:
        "Välkommen till Allbry! Här finns vi tillgängliga för att stötta, motivera och vägleda dig. ",
      klarnaLoadingError:
        "Något gick fel när vi försökte ladda betalningsomdulen, var vänlig försök igen senare",
      klarnaOrderError:
        "Något gick fel när vi försökte bekräfta din betalning, var vänlig försök igen senare",
    },
    forgot: {
      checkStep: "Kolla din e-post!",
      weJustSent: "Vi har skickat en",
      resetPassLink: "återställningslänk för ditt lösenord",
      followInstructions:
        "till din e-post. Kolla din inkorg och följ instruktionerna",
      enterEmail: "Ange din e-postadress",
      createNewPass: "Skapa nytt lösenord",
    },
    registrationError: "Det gick inte att skapa ditt konto",
    signInError: "Felaktigt e-postadress och/eller lösenord",
    forgotPassword: "Glömt lösenord?",
    invalidPassword: "Ogiltigt lösenord",
    externalJoin: {
      title: "Har du fått en möteskod",
      description:
        "Om du har fått en möteskod, vänligen ange den nedan för att komma igång.",
      placeholder: "Ange din möteskod",
      help: "Kontakta organisatören om du inte har en möteskod.",
      invitationMessage: "Du har blivit inbjuden till ett möte",
      invitationDescription:
        "Du har blivit inbjuden till ett möte genom Allbry av {{counselorName}}",
      information: "Information {{description}}",
    },
  },
  navbar: {
    switch: "Ställ dig själv som",
    toOffline: "offline",
    toOnline: "online",
    appointments: {
      title: "Hem",
      text: "Boka ett videosamtal med elevhälsan för ett personligare samtal.",
    },
    messages: {
      title: "Chatt",
      text: "Chatta med elevhälsan när som helst utan att boka tid",
    },
    students: {
      title: "Elever",
    },
    referrals: {
      title: "Remisser",
    },
    reports: {
      title: "Rapporter",
    },
    emailStatistics: {
      title: "E-poststatistik",
    },
    home: {
      title: "Hem",
    },
    organizations: {
      title: "Organisationer",
    },
    profile: "Profil",
    installApp: "Allbry i din mobil",
    installAppSubtitle: "Ett enklare sätt att hålla kontakten",
    clickHere: "Hämta appen",
    settings: {
      title: "Inställningar",
    },
    logOut: "Logga ut",
    [PRINCIPAL_ROUTE_NAME.ORGANIZATION]: {
      title: "Organisation",
    },
    [PRINCIPAL_ROUTE_NAME.STATISTICS]: {
      title: "Statistik",
    },
    [PRINCIPAL_ROUTE_NAME.USERS]: {
      title: "Användare",
    },
    counsellors: {
      title: "Elevhälsopersonal",
    },
    dataMigration: {
      title: "Data Migration",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
    },
    configForm: {
      title: "Config Form",
    },
    notifications: {
      title: "Notifikationer",
      empty: "Inga notiser än",
      today: "Idag",
      yesterday: "Igår",
      all: "Alla",
      unread: "Olästa",
      allCaughtUp: "Du har läst allt.",
      justNow: "Just nu",
      minutesAgo: "{{count}} min sedan",
    },
    superActions: {
      title: "Super Actions",
    },
    checkInsAndSurveys: {
      title: "Tempen",
    },
    config: {
      title: "Tempen",
    },
    broadcastMessages: {
      title: "Sänd meddelanden",
    },
    customReports: {
      title: "Rapporter",
    },
    process: {
      title: "Process",
    },
  },
  notFound: {
    code: "404",
    text: "Sidan gick inte att visa",
  },
  settings: {
    title: "Inställningar",
    billing: {
      title: "Prenumerationsinställningar",
      activeStatus:
        'Din prenumeration är <b class="text-green">aktiv</b> och nästa betalning kommer att inträffa den <b>{{date}}</b>',
      inactiveStatus:
        'Din prenumeration är <b  class="text-red">inaktiv</b>, men ditt konto är tillgängligt till <b>{{date}}</b>',
      manageSubBtn: "Hantera prenumeration",
      cancelSubBtn: "Avbryt prenumeration",
      manageSub: "Hantera prenumeration",
      cancelSub: "Avbryt prenumeration",
      cancelSubSubtitle:
        "Är du säker på att du vill lämna oss? Vi finns alltid här som stöd. Du är självklart välkommen tillbaka närsomhelst! Ditt konto kommer vara fortsatt aktivt fram till {{date}}, sedan säger vi hejdå.",
      confirmCancel: "Bekräfta",
    },
    anonymous: {
      title: "Anonymt läge",
      description:
        "Din organisation tillåter dig att vara anonym. Med denna inställning aktiverad kommer ditt namn och profilbild vara dolt för din elevhälsopersonal. Vi har anmälningsskyldighet i fall vi känner oss oroliga för dig och din omedelbara säkerhet så kan vi identifera dig, även om du är anonym.",
    },
    allowEmailNotification: {
      title: "Mejlnotiser",
      description: "Du kan stänga av mejlnotiser från Allbry",
    },
    prorenataIntegration: {
      title: "Prorenata-integration",
      description:
        "Aktivera integrationen för att starta Prorenata-flöden direkt i Allbry.",
      button: "Hantera",
      statusConnected: "Ansluten",
      statusNotConnected: "Inte ansluten ännu",
      toggleSuccess: "Prorenata-status uppdaterad.",
      toggleError: "Kunde inte uppdatera Prorenata-status.",
    },
    prorenata: {
      configureModal: {
        title: "Konfigurera Prorenata",
        confirm: "Bekräfta",
        verifyTitle: "Är detta du?",
        selectJournalTitle: "Välj standardjournal",
        nameLabel: "Namn",
        personalNumberLabel: "Personnummer",
        initializationError: "Vi kunde inte hämta dina Prorenata-uppgifter.",
        noJournalAccess:
          "Du har just nu ingen behörighet till några journaler i Prorenata.",
        createSuccess: "Begäran skickades till Prorenata.",
        createError: "Kunde inte skapa Prorenata-kopplingen.",
        successTitle: "Klart!",
        successDescription:
          "Nästa gång du skapar en anteckning eller en rapport kan du synka den till Prorenata i det sista steget.",
      },
    },
    calendarSync: {
      title: "Extern kalender synk",
      description: "Aktivera extern kalender synk för boka samtal",
      freeDescription: "Aktivera extern kalendersynk av upplagd tillgänglighet",
      freeNote:
        "Notera: Oftast läggs allt till automatiskt men om det inte sker så följ instruktionerna i mejlet som skickas till dig när du lägger till tillgänglig tid",
    },
    dataReset: {
      recurrentReset: {
        title: "Återkommande återställning av data",
        disabledResetParagraph:
          "Aktivera återkommande återställning av data för att rensa data automatiskt. Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        enabledResetParagraph:
          "Beräknat datum för nästa återställning är {{date}}. Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        intervalLabel: "Intervall",
        intervals: {
          eachMonth: "Varje månad",
          eachThreeMonths: "Varje 3 månader",
          eachSixMonths: "Varje 6 månader",
        },
        errorGettingResetState:
          "Fel när det gäller att hämta status för aktuella återkommande jobb",
        errorSwitchingResetState:
          "Fel vid ändring av status för återkommande jobb",
        errorIntervalChange: "Fel vid ändring av återställningsintervallet",
        successIntervalChange:
          "Ett nytt återställningsintervall har fastställts.",
      },
      manualReset: {
        title: "Återställ data nu",
        paragraph:
          "Observera att återställning av data påverkar chattar, samtalshistorik och minnesanteckningar.",
        resetButton: "Rensa alla uppgifter",
        resetSuccess: "Uppgifterna har raderats",
        resetFailure: "Fel vid återställning av data",
        resetModal: {
          title: "Rensa alla uppgifter",
          paragraph:
            "Är du säker på att du vill återställa all information i chattar, samtalshistorik och minnesanteckningar?",
          yes: "Ja",
          no: "Nej",
        },
      },
    },
    policy: {
      title: "Integritetspolicy",
      description: {
        firstPart: "",
        secondPart: "",
      },
      policyCopy:
        "En kopia av våra användarvillkor och integritetspolicy finns",
      hereLink: "här",
    },
    tutorials: {
      title: "Instruktioner",
      description: "Lär dig hur du använder Allbry",
      hereLink: "här",
    },
    language: {
      title: "Språk",
    },
    changePassword: "Ändra Lösenord",
    currentPassword: "Nuvarande Lösenord",
    newPassword: "Nytt Lösenord",
    confirmPassword: "Bekräfta Nytt Lösenord",
    passwordChanged: "Lösenordet har ändrats",
    unavailable: {
      title: "Out of office",
      description:
        "Fyll i rutan nedan och aktivera till höger för att ställa in ett meddelande som visas för dina elever när de skickar ett meddelande till dig.",
      success: "Texten har uppdaterats",
      unavailableText: "Ange texten här",
      anywaySendMessage:
        "Ge eleven möjlighet att fortsätta skicka meddelanden även om du inte är tillgänglig.",
    },
    onlineStatus: {
      updated: "Status uppdaterad.",
      error: "Fel vid uppdatering av status.",
    },
  },
  profile: {
    personProfile: "{{type}}s profil",
    personProfileName: "{{person}}s profil",
    overview: "Profil",
    edit: {
      title: "Ändra profil",
      restriction: "Endast administratörer kan ändra",
      gender: {
        male: "Man",
        female: "Kvinna",
        other: "Annat",
        private: "Vill inte svara",
      },
      about: "Om",
      changesSaved: "Ändringar sparade",
    },
    personalInfo: "PERSONLIGA UPPGIFTER",
    personAttributes: "ATTRIBUT",
    contactInfo: "KONTAKTUPPGIFTER",
    about: "Om mig",
    name: "Namn",
    selectRole: "Välj roll",
    birthday: "Födelsedatum",
    fullBirthday: "{{birthday}} ({{fullYears}} år)",
    appointments: "SAMTAL",
    noAppointments: "Inga samtal hittades för denna kategori",
    gender: "Kön",
    age: "Ålder",
    email: "E-postadress",
    lastNote: "{{person}}s senaste anteckning kommer visas här.",
    parentAccountID: "Parent account ID",
    noParentIfEmpty: "Ingen parent om den är tom",
    secretIdentity: "Skyddad identitet",
    createReport: "Skapa rapport",
    studentReport: "Elevrapport",
    attributeHistory: "Attributhistorik",
    noAttributeHistory: "Ingen historik hittades",
  },
  appointments: {
    title: "Samtal",
    activities: "Aktiviteter",
    addNew: "Skapa",
    session: {
      today: "Gå med i samtalet",
      future: "Avbokning eller ombokning",
      completed: "Nytt samtal",
      cancelled: " Nytt samtal",
      cancel: "Avboka",
    },
    status: {
      upcoming: "Kommande",
      completed: "Avslutade",
      cancelled: "Avbokade",
      unanswered: "Väntar på svar från {{name}}",
      pending: "Väntar på svar från dig",
      active: "Accepterad",
    },
    action: {
      accept: "Godkänn",
      reschedule: "Ombokning",
      deny: "Avböj",
      goToAppointment: "Gå till bokningen",
    },
    unansweredDialog: {
      title: "Du har obesvarande samtalsförfrågningar",
      continueBtn: "Fortsätt senare",
    },
    booking: {
      title: {
        booking: "Bokning",
        reschedule: "Omplanera",
      },
      commentAndDescription: "Kommentar / beskrivning",
      descriptionText:
        "Lägg till en kommentar eller beskrivning till ditt möte som kommer att vara synlig för de andra deltagarna",
      descriptionPlaceholder: "Ange beskrivning",
      descriptionMaxLengthWarning: "Du kan lägga till maximalt 250 tecken",
      schedule: "Boka",
      chooseStudent: "Välj elev",
      selectStudent: "Välj elev",
      chooseUser: "Välj användare",
      selectUser: "Välj användare",
      sessionDuration: "Samtalets längd",
      sessionTime: "Samtalets tid",
      success: "Klart",
      successText: "Du kan se din bokning under kommande samtal",
      successBooked: "bokat",
      successRescheduled: "ombokat",
      back: "Okej",
      chooseUserModal: "Välj användare",
      chooseStudentModal: "Välj elev",
      done: "Klart",
      chooseCounsellor: "Välj elevhälsopersonal",
      chooseCounsellorModal: "Välj elevhälsopersonal",
      selectCounsellor: "Välj elevhälsopersonal",
      searchStudents: "Sök elev",
      recommendedSlotsMassage:
        "Inga tillgängliga tider, välj ett annat datum eller välj en av de rekommenderade tiderna nedan",
      recommendedSlots: "Rekommenderade tider",
      noTimeSlots: "Inga tillgängliga tider",
      custom: "Anpassad tid",
      startTime: "Starttid",
      endTime: "Sluttid",
      video: "Video",
      students: "Elever",
      counsellors: "Elevhälsopersonal",
      search: {
        student: "Sök elev",
        counsellor: "Sök hälsopersonal",
      },
      notFound: {
        student: "Ingen elev hittades",
        counsellor: "Ingen elevhälsopersonal hittades",
      },
      selectExternal: "Lägg till extern",
      name: "Namn",
      number: "Telefonnummer",
      email: "Epost",
      participantLimitReached:
        "Du kan lägga till högst {{count}} deltagare, inklusive externa deltagare. Ta bort en för att lägga till en annan.",
    },
    detail: {
      scheduleInfoCancelOrReschedule:
        "Samtalet är bokat per {{date}}, klockan {{time}}. Du kan närsomhelst avboka eller omboka samtalet. ",
      scheduleInfoBookAnother:
        "Samtalet är bokat per {{date}}, mellan kl {{start}} - {{end}}. Du kan alltid boka flera samtal.",
      reschedule: "Omboka",
      cancel: "Avboka",
      areYouSure: "Är du säker på att du vill avboka ditt samtal?",
      yes: "Ja, avboka",
      cancelled: "Samtalet är avbokat",
      sessionDetails: "Samtalets detaljer",
      externalUserInfo: "Extern användarinformation",
      copied: "Kopierad",
      copyError: "Kunde inte kopiera",
      resendEmailToExternalUser:
        "Är du säker på att du vill skicka e-postmeddelandet igen till den externa användaren?",
      description: "Beskrivning",
    },
    now: "Nu",
    scheduleNew: "Nytt samtal",
    counsellors: "Hej, snacka med mig!",
    appointments: "Samtal",
    seeAll: "Se alla",
    notExist: "Samtalet finns inte",
    weeksInterval: "Om {{interval}} veckor",
    daysInterval: "Om {{interval}} dagar",
    dayInterval: " Om {{interval}} dag",
    hoursInterval: " Om {{interval}} timmar",
    hourInterval: " Om {{interval}} timme",
    minutesInterval: " Om {{interval}} minuter",
    minuteInterval: " Om {{interval}} minut",
    today: "Idag",
    future: "Framtiden",
    completed: "Avslutad",
    cancelled: "Avbokad",
    organizationNotWorking: "Organisationen arbetar inte denna dag",
    noAppointments: "Inga samtal här ännu...",
    scheduleFirst: "Boka ditt första samtal",
    yourFreeTime: "Din tillgänglighet",
    freeTime: {
      title: "Din tillgänglighet",
      addTime: "Lägg till tid",
      noFreeTimes:
        "Här avsätter du dina tillgängliga tider för samtal. Under dessa tider kan du boka in elever på individuella samtal och eleverna kan även boka dig.",
      allocateTime: "Bokningsbar tid",
      startTime: "Starttid",
      endTime: "Sluttid",
      editTime: "Redigera tillgänglig tid",
      add: "Lägg till",
      cancel: "Annullera",
      date: "Datum",
      ends: "Slutar",
      orgNotWorking: "Organisationen har inte öppet",
      repeats: {
        everyday: "Varje dag",
        weeklyOn: "Varje vecka på {{day}}",
        weekdays: "Varje vardag (måndag till fredag)",
        none: "Upprepas inte",
      },
      deleteModal: {
        title: "Ta bort tillgänglig tid",
        description: "Är du säker på att du vill ta bort din tillgängliga tid?",
        delete: "Ja, ta bort",
      },
      timeAdded: "Din tillgängliga tid lades till",
      timeEdited: "Din tillgängliga tid har redigerats",
      timeDeleted: "Din tillgängliga tid raderades",
    },
    customMeeting: "Välj mötestyp",
    error: {
      studentOrCounsellor:
        "Elev eller personal är inte tillgänglig mellan {{data}}",
      and: "och",
      counsellor: "Personal är inte tillgänglig denna tid",
      timeError: "Sluttiden måste vara större än starttiden",
      minimumTime: "Samtalet måste vara längre än {{minimumTime}} minuter",
      currentTime: "Starttiden måste vara större än aktuell tid",
      outsideWorkingHours:
        "Vald tid ligger utanför organisationens arbetstider",
      noAvailableTime: "Elev eller personal är inte tillgänglig för närvarande",
    },
    invited: "{{count}} inbjudna",
    participants: "{{count}} deltagare",
  },
  reminderBoard: {
    todo: "Kommande",
    inProgress: "Pågår",
    done: "Klart",
    viewAndEdit: "Visa och redigera",
    createdAt: "Skapad den:",
    attachedTo: "Kopplad till:",
    createdBy: "Skapad av:",
    title: "Titel",
    description: "Beskrivning",
    dueDate: "Förfallodatum",
    personOfInterest: "Berörd elev",
    reminderBoard: "Påminnelser",
    createReminder: "Skapa påminnelse",
    titlePlaceholder: "Ange titel här",
    descriptionPlaceholder: "Ange beskrivning här",
    personOfInterestPlaceholder: "Välj berörd elev",
    searchStudents: "Sök elever",
    noResults: "Inga resultat",
    addUser: "Lägg till",
    addNew: "Lägg till",
    editUser: "Redigera användare",
    selectDueDate: "Välj förfallodatum",
    chooseStudent: "Välj elev",
    archive: "Arkivera",
    archiveConfirmationTitle:
      "Är du säker på att du vill arkivera påminnelser?",
    deleteConfirmationTitle: "Är du säker på att du vill ta bort påminnelser?",
    reminders: "Påminnelser",
    viewArchived: "Visa arkiverade",
    todoDescription: 'Dra påminnelsen till "pågår" med musen',
    doneDescription:
      "Klara påminnelser äldre än 30 dagar flyttas automatiskt till arkivet",
  },
  notes: {
    title: "Anteckningar & rapporter",
    note: "Anteckning",
    report: "Elevrapport",
    topics: "Ämnen",
    meetingType: "Mötestyp",
    meetingKind: "Mötesplats",
    meetingDuration: "Möteslängd",
    student: "Elev",
    generated: "Genererad",
    add: "Skapa anteckning",
    personNotes: "{{person}}s anteckningar & rapporter",
    personNote: "{{person}}s anteckning",
    personReport: "{{person}}s rapport",
    personStatistics: "{{person}}s Statistik",
    create: "Skapa ny anteckning",
    saveText:
      "Skapa minnesanteckningar om eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet.",
    autoSaveText:
      "Skapa minnesanteckningar om eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet. Anteckningarna sparas automatiskt. ",
    autoSaveTextDuringVideo:
      "Skapa minnesanteckningar om eleven, dem är endast synliga för dig och andra med samma profession som dig i elevhälsoteamet. Anteckningarna sparas automatiskt.",
    metaAppointment:
      "{{person}} har avslutat ett samtal med {{student}}, {{date}}",
    metaChat:
      "{{person}} har avslutat en chattkonversation med {{student}}, {{date}}",
    createdBy: "{{date}} av {{person}}",
    delete: "Ta bort anteckningen",
    deleteQuestion: "Är du säker på att du vill ta bort den här anteckningen?",
    yes: "Ja, ta bort",
    edit: "Redigera anteckning",
    editQuestion: "Är du säker på att du vill redigera den här anteckningen?",
    yesEdit: "Ja, redigera",
    saved: "Anteckningen har sparats",
    deleted: "Anteckningen har raderats",
    worryLevel: "Orosnivå",
    filter: "Filter",
    notes: "Anteckningar",
    reports: "Rapporter",
    isPinned: "Fäst anteckning",
    prorenataToggle: "Skicka till Prorenata",
    prorenataSuccess: "Anteckningen skickades till Prorenata.",
    prorenataError: "Det gick inte att skicka anteckningen till Prorenata.",
    pinnedNotes: "Den här anteckningen är fäst",
    isNotPinned: "Den här anteckningen är inte fäst",
    isPublic: "Öppen",
    isForPublic:
      "Denna anteckningen är synlig för kollegor med andra professioner",
    isNotForPublic:
      "Denna anteckningen är inte synlig för kollegor med andra professioner",
    isUpdated: "Denna anteckning har uppdaterats",
    publicLabel: "Öppen",
    pinnedLabel: "Fäst",
    isForReportPublic:
      "Denna rapport är synlig för kollegor med andra professioner",
    isReportNotForPublic:
      "Denna rapport är inte synlig för kollegor med andra professioner",
    myReports: "Mina rapporter",
    pdf: {
      title: "Anteckningssammanfattning",
      createdBy: "Skapad av",
      createdAt: "Skapad",
      content: "Anteckningsinnehåll",
      generatedAt: "Genererad",
    },
  },
  videoCall: {
    leaveCallModal: {
      title: "Avsluta samtalet",
      paragraph:
        "Har du redan gjort ditt samtal? Klicka i så fall på avsluta samtalet och fyll i rapporten. Om inte, klickar du på Lämna samtalet så kan du återgå till samtalet.",
      leaveCall: "Lämna samtalet",
      endCall: "Avsluta samtalet",
    },
    videoAccessModal: {
      title: "Kameran eller mikrofonen är blockerad",
      description_1:
        "Allbry kräver åtkomst till din kamera och mikrofon. Klicka på ikonen för blockerad kamera",
      description_2: "i webbläsarens adressfält.",
      leaveCall: "Lämna samtalet",
    },
    join: "Ansluten",
    notJoin: "Ej ansluten",
  },
  chat: {
    end: "Avsluta chatt",
    archivedForCounsellor:
      "Eleven har arkiverat chatten. Det betyder att chatten är rensad för eleven och den ser inte tidigare meddelanden. För att starta om konversationen behöver du bara skriva något.",
    endInfoForCounsellor:
      "Chatten avslutades kl {{time}} av dig. Skriv ett meddelande för att starta chattkonversationen på nytt. ",
    startInfoForCounsellor:
      "Den här chatten startades den {{time}} av dig. För att starta konversationen behöver du bara skriva något.",
    chatStarted: "(Chatt startad)",
    noMessages: "Vad tänker du på?",
    sendFirstMessage: "Skriv vad som helst för att börja!",
    writeMessage: "Skriv ett meddelande...",
    endChatQuestion:
      "Är du säker på att du vill avsluta chatten? Chatten kommer inte försvinna och du kan närsomhelst starta den igen genom att skicka ett nytt meddelande.",
    attachmentInfo: "{{fileSize}}, {{date}} kl {{time}}",
    sharedFiles: "DELADE FILER",
    noFiles: "Inga filer har delats än...",
    viewFileInfo: "Visa filinfo",
    deleteFile: "Ta bort fil",
    fileDetails: "Filinformation",
    fileName: "Filnamn",
    fileSizeLabel: "Filstorlek",
    typeLabel: "Typ",
    createdAtLabel: "Skapad",
    createdByLabel: "Skapad av",
    descriptionLabel: "Beskrivning",
    informationTitle: "Information",
    noDescription: "Ingen beskrivning",
    deleteFileQuestion: 'Är du säker på att du vill ta bort "{{fileName}}"?',
    fileDeleted: "Filen har tagits bort",
    fileDeleteError: "Det gick inte att ta bort filen",
    general: "Alla",
    messages: "Meddelanden",
    chatEnded: "(Chatt avslutad)",
    attachment: "(Bilaga)",
    image: "(Bild)",
    startTitle: "Vem vill du chatta med?",
    noStudentsFound: "Inga elever hittades",
    notFoundLabels: {
      student: "Ingen elev hittades",
      counsellor: "Ingen elevhälsopersonal hittades",
      globalCounsellor: "Ingen global studenthälsopersonal hittades",
    },
    noStudentsAvailable: "Inga elever är tillgängliga",
    noStudentsAvailableToChat:
      "Det finns inga tillgängliga elever att starta en chatt med",
    noCounsellorsAvailable: "Ingen elevhälsopersonal är tillgänglig",
    noCounsellorsAvailableToChat:
      "Det finns ingen tillgänglig elevhälsopersonal att starta en chatt med",
    start: "Starta chatt",
    startGroupChat: "Starta gruppchatt",
    nameTheGroupChat: "Namnge gruppchatten",
    enterGroupName: "Ange ett namn för gruppchatten",
    groupName: "Gruppens namn",
    more: "Se mer",
    selectChat:
      "Välj en chatt och skicka ett meddelande eller skriv ett nytt meddelande.",
    archive: "Arkiverat",
    delete: "Ta bort chatt",
    organizationDoesntWork:
      "Allbry är inte öppet just nu. Du kan självklart fortfarande skicka ditt meddelande så svarar vi så fort vi kan. Vi har öppet och elevhälsopersonal finns på plats mellan {{start}} och {{end}}.",
    organizationDoesntWorkToday:
      "Skolan är stängd över sommaren. Det kommer att ta längre tid att få svar, men på mobilen har du fortfarande tillgång till flera olika stödlinjer.",
    endInfoForStudent:
      "Chatten avslutades kl {{time}} av {{person}}. Du kan närsomhelst starta den igen genom att skicka ett nytt meddelande.",
    startInfoForStudent:
      "Den här chatten startades den {{time}} av {{person}}. För att starta konversationen behöver du bara skriva något.",
    sendAfterWork: "Skicka meddelande utanför Allbrys öppettider",
    workingHours:
      "Allbry har öppet mellan {{start}} och {{end}}. Du kan självklart fortfarande skicka ditt meddelande så svarar vi så fort vi kan.",
    workingHoursToday:
      "Organisationen har inte öppet idag. Du kan skicka meddelanden utanför arbetstid, observera dock att du får svar inom arbetstid.",
    ok: "Jag förstår",
    deleteChatQuestion: "Är du säker på att du vill ta bort chatten? ",
    archiveChat: "Arkivera chatt",
    unarchiveChat: "Återställ chatt",
    deleted: "Chatten raderad",
    archived: "Chatten arkiverad",
    unarchived: "Chatten har återställts",
    deleteGroup: "Ta bort grupp",
    modifyGroup: "Ändra grupp",
    groupAllMembers: "Gruppmedlemmar",
    modifyGroupChat: "Redigera gruppchatt",
    editGroupName: "Ange ett namn för gruppchatten",
    members: "Deltagare",
    confirmToDelete: "Är du säker på att du vill ta bort gruppen?",
    confirmToDeleteMember: "Är du säker på att ta bort vald deltagare?",
    addNewMember: "Lägg till deltagare",
    deleteSelected: "Ta bort vald deltagare",
    selectNewMember: "Välj deltagare",
    selectClose: "Välj & stäng",
    noMembersInGroup:
      "Det finns inga medlemmar i den här gruppen. Vill du ta bort gruppen?",
    groupMembers: "{{value}} deltagare",
    overview: "Översikt",
    notesAndReports: "Anteckningar & rapporter",
    statistics: "Statistik",
    imageFile: "Bild eller bilaga",
    akkImage: "Bildstöd",
    read: "Läst",
    akk: {
      selectCategory: "Välj kategori",
      chooseAkk: "Välj bilder",
      send: "Skicka",
      noImage: "Inga bilder hittades",
    },
    all: "Alla",
    students: "Elever",
    counsellors: {
      shortName: "Lokala",
      fullName: "Elevhälsopersonal på skolan",
    },
    globalCounsellors: {
      shortName: "Globala",
      fullName: "Elevhälsopersonal inom organisationen",
    },
    searchStudent: "Sök elev",
    searchCounsellor: "Sök elevhälsopersonal",
    searchGlobalCounsellor: "Sök global elevhälsopersonal",
    active: "Registrerad",
    inactive: "Inaktiv",
    deactivated: "Inaktiverad",
    successDelete: "Meddelandet har raderats",
    counsellorUnavailable: "Personal är inte tillgänglig",
    videoCall: "Videosamtal",
    confirmVideoCall: "Är du säker på att du vill starta ett videosamtal?",
    counsellorInactive: "Personen arbetar inte längre på skolan",
    onlyAllbryCanSendMessage: "Endast {{name}} kan skicka meddelanden",
    messagesTitleSuperAdmin: "Meddelanden (tekniska releaser)",
    showMore: "Visa mer",
    createReportFor: "Skapa rapport för {{date}}",
    conversationHasEnded: "Konversationen har avslutats automatiskt.",
  },
  reports: {
    createReport: "Skapa elevrapport",
    deleteReport: "Ta bort rapport",
    editReport: "Redigera rapport",
    editReportQuestion: "Är du säker på att du vill redigera rapporten?",
    deleteReportQuestion: "Är du säker på att du vill ta bort rapporten?",
    yesEdit: "Ja, redigera",
    yes: "Ja, radera",
    deleted: "Rapporten har raderats",
    title: "Elevrapport",
    title2: "Friviligt steg",
    selectDate: "1. Datum",
    selectTopics: "2. Vilka ämnen har berörts under samtalet?",
    concernScale: "3. Hur orolig är du för eleven?",
    selectMeetingType: "4. Vad för typ av samtal har ni haft?",
    selectMeetingKind: "5. Hur ägde samtalet rum?",
    noteComment: "{{questionNo}}. Anteckning / Kommentar",
    feedbackAllbry:
      "{{questionNo}}. Finns det något annat du vill kunna kartlägga? (valfri marknadsundersökning)",
    additionalSupportQuestionTitle:
      "{{questionNo}}. Är eleven i behov av ytterligare stöd?",
    participationThanks: {
      title: "Tack!",
      details:
        "Tack för att du fyllt i elevrapporten. Dessa används för att kunna få insikt i hur eleverna mår och vad dem pratar om för att göra en bra kartläggning av eleverna.",
      close: "Stäng",
    },
    topics: {
      startOfSession: "Sökt kontakt (startat samtal)",
      checkIn: "Check-in",
      basicCare: "Grundläggande omsorg",
      identity: "Identitet",
      anxiety: "Ångest",
      stress: "Stress",
      physicalHealth: "Fysisk hälsa",
      training: "Träning",
      crime: "Kriminalitet",
      sorrow: "Sorg",
      socialRelationship: "Sociala relationer",
      workLife: "Arbetsliv",
      shame: "Skam",
      honor: "Heder",
      careFailure: "Omsorgssvikt",
      economy: "Ekonomi",
      security: "Säkerhet",
      stimulationAndGuidance: "Stimulans och vägledning",
      socialOrientation: "Samhällsorientering",
      emotionalAvailability: "Känslomässig tillgänglighet",
      love: "Kärlek",
      mentalHealth: "Psykisk hälsa",
      mentalAbuse: "Psykisk misshandel",
      physicalAbuse: "Fysisk misshandel",
      loveRelations: "Kärleksrelationer",
      familyRelations: "Familjerelationer",
      sexualAbuse: "Sexuellt övergrepp",
      economicalAbuse: "Ekonomisk misshandel",
      drugUse: "Droganvändning",
      performanceAnxiety: "Prestationsångest",
      loneliness: "Ofrivillig ensamhet",
      grooming: "Grooming",
      school: "Skola",
      education: "Utbildning",
      selfHarm: "Självskadebeteende",
      suicidalToughts: "Självmordstankar",
      religion: "Religion",
      politics: "Politik",
      sexuality: "Sexualitet",
      npfDiagnoses: "NPF-diagnoser",
    },
    meetingType: {
      emergencyMeeting: "Akutmöte",
      dropInMeeting: "Drop-in möte",
      individualMeeting: "Enskilt möte",
      noShowMeeting: "Uteblivet möte",
      parentMeeting: "Möte med vårdnadshavare",
      ehtMeeting: "Möte med representant från EHT",
      groupMeeting: "Gruppmöte med elever",
      adultMeeting: "Möte med annan vuxen (t.ex. lärare)",
      breakMeeting: "Samtal i korridor eller under rast",
      adultStudentMeeting:
        "Samtal med elev, VH, rektor och / eller annan skolpersonal",
    },
    meetingKind: {
      allbryMeeting:
        "Bokade du ett fysiskt möte eller videosamtal genom Allbry?",
      allbryMeetingIfNot: "Om inte, ange vilken typ av möte du haft",
      telephone: "Telefonmöte",
      digital: "Digitalt möte",
      physical: "Fysiskt möte",
    },
    prorenataToggle: {
      title: "Synka till Prorenata",
      description: "Synka rapporten till Prorenata",
      success: "Rapporten skickades till Prorenata.",
      error: "Det gick inte att synka rapporten till Prorenata.",
    },
    saveError: "Det gick inte att spara rapporten. Försök igen.",
    addTopic: {
      title: "Lägg till ämne",
      name: "Namn",
      description: "Beskrivning",
      button: "Lägg till ny",
      success: "Ämnet har lagts till",
      error: "Det gick inte att lägga till ämne",
      expandTab: "Expandera",
      collapseTab: "Kollapsa",
      all: "Alla",
    },
    worriedLevel: {
      level0: "Ingen oro / sökt kontakt",
      level0_5: "Risk på väg mot nivå 1 ",
      level1:
        "Förebyggande / främjande / informerande samtal eller övriga samtal",
      level1_5: "Risk på väg mot nivå 2",
      level2: "Mild oro – oro som du kan hantera med eleven",
      level2_5: "Risk på väg mot nivå 3",
      level3:
        "Medel oro - kontakta skolan och uppföljning efter 4 veckor eller hänvisa till BUP / psykiatrin & andra instanser",
      level3_5: "Risk på väg mot nivå 4",
      level4: "Hög oro – orosanmälan eller liknande",
      level4_5: "Risk på väg mot nivå 5",
      level5: "Akut oro - agera nu, larma till räddningstjänst eller liknande",
      details0:
        "Ingen oro / sökt kontakt \n\nIngen oro vid det här stadiet. Eleven har sökt kontakt eller startat ett samtal. ",
      details0_5: "Risk på väg mot nivå 1.",
      details1:
        "Förebyggande / främjande / informerande samtal eller övriga samtal \n\nVid den här nivån har elevhälsopersonal haft förebyggande/främjande/informerande samtal eller andra typer av stödsamtal. Exempelvis om vänskapsrelationer, kärlek, framtid och fritid eller mål och drömmar och liknande teman/ämnen.\n\nVägledande samtal i samband med exempelvis gymnasieansökan (för grundskoleelever) eller universitetsansökan (för gymnasieelever). ",
      details1_5: "Risk på väg mot nivå 2.",
      details2:
        "Mild oro – oro som du kan hantera med eleven \n\nVid den här nivån känner elevhälsopersonal en mild oro för eleven. Det innebär oro där kurator/elevhälsopersonal och elev kan samtala om ämnen/teman utan att behöva meddela andra (tystnadsplikt). Det kan gälla samtal om självkänsla, självförtroende, tidigare trauman, relationer och hälsa och erfarenheter som eleven berättar om.\n\nI det här stadiet av oro kan kurator/elevhälsopersonal med sina färdigheter, kunskaper och samtalsmetoder arbeta med eleven och stötta vid olika lägen och situationer. \n\nRelationsskapande, förtroende och tillit är viktiga i denna nivå då en elev kanske berättar något i förtroende till elevhälsopersonal som eleven inte vill ska komma ut till någon annan men som ändå behöver hjälp, ett exempel är låg självkänsla, berättar om NPF-diagnoser, utredningar, tidigare kontakt med myndigheter som socialtjänst och BUP eller vuxenpsykiatrin.\n\nDet finns en oro för eleven men du som elevhälsopersonal finns som stöd och reder ut oron.",
      details2_5: "Risk på väg mot nivå 3.",
      details3:
        "Medel oro - kontakta skolan och uppföljning efter 4 veckor eller hänvisa till BUP / psykiatrin & andra instanser \n\nDetta är det första steget där elevhälsopersonal ska agera och bryta mot sekretessen (tystnadsplikt). I det här fallet handlar det om att kontakta skolan vid oro kring barnets hälsa (psykisk och fysisk hälsa), skolgång, skolresultat, hemmamiljö, utfrysning och mobbning. Kränkande behandling. Vid första steg kontaktas kurator eller mentor. Eventuellt ett ärende för EHT/EHM att diskutera denna elev exempelvis vid anpassningar, svårigheter i skolan. Uppföljning för eleven sker efter 4 veckor, kurator ansvarar för uppföljning.",
      details3_5: "Risk på väg mot nivå 4.",
      details4:
        "Hög oro – orosanmälan eller liknande \n\nUtifrån Socialstyrelsens styrdokument samt anmälningsskyldighet enligt SoL 14kap 1§ & SkolL 29kap 13§, skyldighet att anmäla vid kännedom eller misstanke om att barn far illa. Elevhälsopersonal meddelar eleven (och föräldrarna i vissa fall) och informera om att en orosanmälan görs och varför den görs. Skolan skall alltid vara informerade. En orosanmälan görs vanligtvis i samarbete med rektor.\n\nSocialstyrelsens (2013) definition av begreppet ”barn som far illa” ur Barn som far illa eller riskerar att fara illa. En vägledning för hälso- och sjukvården samt tandvården gällande anmälningsskyldighet och ansvar.\n\n”Begreppet barn som far illa innefattar alla former av övergrepp, försummelse och utnyttjande som leder till faktisk eller potentiell skada för barnets hälsa eller utveckling. Det kan till exempel avse barn och ungdomar som i hemmet utsätts för fysiskt eller psykiskt våld, sexuella övergrepp, kränkningar eller problem i förhållande till sin familj, likaså om det blir vittne till våld eller lever i en miljö där våld och hot om våld förekommer. Vidare ingår barn och ungdomar som far illa på grund av sitt eget beteende, exempelvis på grund av missbruk, kriminalitet och annat självdestruktivt beteende. Barn som utsätts för hot, våld eller andra övergrepp från jämnåriga eller från andra, samt barn med stora problem i skolsituationen föranledda av en social problematik kan också anses ingå i socialtjänstens målgrupp.””Begreppet barn som far illa innefattar alla former av övergrepp, försummelse och utnyttjande som leder till faktisk eller potentiell skada för barnets hälsa eller utveckling. Det kan till exempel avse barn och ungdomar som i hemmet utsätts för fysiskt eller psykiskt våld, sexuella övergrepp, kränkningar eller problem i förhållande till sin familj, likaså om det blir vittne till våld eller lever i en miljö där våld och hot om våld förekommer. Vidare ingår barn och ungdomar som far illa på grund av sitt eget beteende, exempelvis på grund av missbruk, kriminalitet och annat självdestruktivt beteende. Barn som utsätts för hot, våld eller andra övergrepp från jämnåriga eller från andra, samt barn med stora problem i skolsituationen föranledda av en social problematik kan också anses ingå i socialtjänstens målgrupp.”",
      details4_5: "Risk på väg mot nivå 5.",
      details5:
        "Akut oro - agera nu, larma till räddningstjänst eller liknande \n\nAgera genast. Vid det här stadiet är det omedelbar fara för elevens liv eller hälsa, eller andra situationer där action måste genomföras genast. Ring 112. Kontakta räddningstjänst. Det kan vara att en elev skriver att den skall genomföra ett självmordsförsök, begå ett brott eller utsätta sig själv eller någon annan i omedelbar fara. ",
      title: "Information nivå ",
    },
    types: {
      quick: {
        title: "Snabb",
        description: "Endast ett begränsat antal ämnen",
        selectTopics: "1. Välj ämnet i konversationen",
        selectMeetingKind: "2. Hur ägde samtalet rum?",
      },
      normal: {
        title: "Normal",
        description: "Rapport i full längd",
      },
    },
    additionalSupport: {
      youthReception: "Ungdomsmottagning",
      socialServices: "Socialtjänst",
      medicalAndHealthcare: "Sjuk- och hälsovård",
    },
    statistics: {
      additionalSupport: "Ytterligare stöd",
    },
  },
  principal: {
    validation: {
      notEmpty: "Värdet kan inte vara tomt",
      noSpaces: "Värdet kan inte ha mellanslag",
      lessThan30Symbols: "{{value}} bör vara mindre än 30 tecken",
      maxName: "Namn bör vara kortare än {{max}} tecken",
      exists: "Attributet finns redan",
      ageLessThan8: "Din ålder får inte vara lägre än 8 år",
      ageLessThan18: "Din ålder får inte vara lägre än 18 år",
      required: "{{value}} krävs",
      requiredName: "Namn krävs",
      requiredEmail: "E-postadress krävs",
      notValidEmail: "Inte giltig e-postadress",
      roleRequired: "Roll är obligatoriskt",
      selectAtLeastOneJournal: "Välj minst en journaltyp",
    },
    addCustomField: "Lägg till ett anpassat fält",
    overview: "{{name}} Översikt",
    schedule: "Verksamhetsschema",
    addCustomAttributes: "Lägg till anpassade attribut",
    customFieldsDescription:
      "Du kan mäta och följa upp olika attribut, t.ex. årskurs eller klass.",
    anonymous:
      "Eleverna i din organisation får vara anonyma. Deras namn och profilbilder kommer att vara dolda för andra användare.",
    removeChatTitle: "Ta bort chattar",
    removeChatDescription:
      "Elever i din organisation får ta bort chattar med elevhälsopersonal.",
    archiveChatTitle: "Arkivera chattar",
    archiveChatDescription:
      "Eleverna i din organisation får arkivera chattar med elevhälsopersonal.",
    addCustomMeetingTypes: "Skapa anpassade mötestyper",
    addMeetingType: "Skapa anpassad mötestyp",
    createMeetingType: "Skapa mötestyp",
    editMeetingType: "Redigera mötestyp",
    chooseMeetingTypeEN: "Ange mötestypens namn på engelska",
    chooseMeetingTypeSW: "Ange mötestypens namn på svenska",
    meetingDescriptionSW: "Ange en beskrivning på svenska",
    meetingDescriptionEN: "Ange en beskrivning på engelska",
    videoEnable: "Video aktiverat",
    meetingCreated: "Mötestypen är skapad",
    errorCreateMeeting: "Det gick inte att skapa mötestypen",
    updatedMeeting: "Mötestypen är ändrad",
    errorUpdatingMeeting: "Det gick inte att uppdatera mötestypen",
    removeMeeting: "Mötestypen är borttagen",
    errorRemovingMeeting: "Det gick inte att radera mötestypen",
    MeetingNameRequired: "Namn på mötestypen är obligatoriskt",
    confirmRemoveMeeting: "Är du säker på att du vill ta bort mötestypen?",
    removePopup: "Är du säker på att du vill ta bort mötestypen?",
    video: "Video",
    editMeeting: "Redigera",
    to: "Till",
    from: "Från",
    workingHours: "Arbetstid",
    custom: "Anpassad",
    weekDays: "Veckodagar",
    allDays: "Alla dagar",
    appointmentTypeDescription:
      "Den initiala Videomötestypen försvinner om en ny videomötestyp läggs till",
    sessionDuration: "Välj samtalets varaktighetstid",
    sessionDurationNote:
      "Notera: Se till att du gör ett val, eftersom om inget alternativ är valt så kommer standardalternativen 20 minuter och 50 minuter väljas",
    days: {
      monday: "Måndag",
      tuesday: "Tisdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lördag",
      sunday: "Söndag",
    },
    startLaterThanEnd: "Starttiden är senare än sluttiden",
    endBeforeStart: "Sluttiden är före starttiden",
    edit: "Redigera användare",
    add: "Lägg till användare",
    student: "Elev",
    counsellor: "Kurator",
    allbryCounsellor: "Allbry Kurator",
    userCreated: "Användaren skapades framgångsrikt.",
    errorCreatingUser: "Fel vid skapande av användaren",
    userUpdated: "Användaren uppdaterades framgångsrikt.",
    errorUpdatingUser: "Fel vid uppdatering av användaren",
    errorUpdatingJournalAccess: "Fel vid uppdatering av journalåtkomst",
    userTable: {
      viewProfile: "Visa profil",
      editProfile: "Redigera profil",
      users: "användare",
      active: "Registrerad",
      inactive: "Inaktiv",
      deactivated: "Inaktiverad",
      nameSurname: "Namn Efternamn",
      birthday: "Födelsedatum",
      organization: "Organisation",
      activate: "Aktivera",
      deactivate: "Inaktivera",
      profileActivated: "Profil aktiverad",
      profileDeactivated: "Profilen är inaktiverad",
      activatingError: "Fel vid aktivering av profil",
      deactivatingError: "Fel vid avaktivering av profil",
      generateCsvTemplate: "Generera csv-mall",
      generateXlsxTemplate: "Generera xlsx-mall",
      importUsers: "Importera användare från xls eller xlsx",
      csvImportTitle: "Import pågår",
      csvImportBody:
        "Det kan ta lite tid att importera användare. Stäng inte fönstret",
      importButton: "Importera",
      selectFiles: "Välj den fil som ska importeras",
      importTitle: "Importera användare",
      usersAddSuccess: "Användare har lagts till",
      usersAddError: "Fel vid import av användare",
      importSummary: "{{created}} skapade, {{updated}} uppdaterade",
      importRolledBack:
        "Import misslyckades: {{failed}} av {{total}} rader ogiltiga. Inget importerades — åtgärda de listade raderna och ladda upp igen.",
      wrongFormat: "Filformatet ska vara xls eller xlsx",
      wrongImportData: "Fel i rad {{row}}:\n{{error}}",
      validationError: "{{field}} ✑ {{error}}",
      onboardingEmailDialogInstruction:
        "Du kommer att skicka onboardingmejl till följande användare",
      inActivateMultipleUserDialogInstruction:
        "Du kommer att inaktivera följande användare",
      scrapeMultipleUserDialogInstruction:
        "Du kommer att ta bort följande användare",
      sendEmail: "Skicka mejl",
      onboardingEmail: "Onboardingmejl",
      customEmail: "Anpassat mejl",
      disableStudent: "Inaktivera elever",
      disableUser: "Inaktivera användare",
      actions: "Åtgärder",
      usersDelete: "Ta bort användare",
      requestScrapeSuccess: "Användarna är borttagna",
      changeAttributesSuccessMessage: "Attribut har ändrats",
      changeAttributes: "Ändra attribut",
      deactivatedSuccessMessage: "Användaren är inaktiverad",
      importDescription:
        "Du kan lägga till en beskrivning för importprocessen här.",
      importDescriptionPlaceholder: "Ange beskrivning här...",
    },
    csv: {
      custom: "Fyll i ett anpassat attribut",
      email: "Fyll i personens e-postadress",
      role: "Fyllnadsnummer: 1 - studerande, 2 - rådgivare",
      gender: "Fyllnadsnummer: 1 - man, 2 - kvinna, 3 - annan",
      year: "Födelseår",
      month: "Födelsemånad (nummer)",
      day: "Födelsedag",
      nameSurname: "Fyll i personens namn och efternamn",
      dateOfBirth: "Födelsedatum: yyyymmdd",
      fillNumber: "Ange nummer",
      workSheetName: "Blad 1",
      externalId: "Fyll i personens externa id (valfritt)",
    },
    csvFields: {
      custom: "Anpassat attribut",
      email: "E-post ",
      role: "Roll",
      gender: "Kön",
      year: "Födelseår",
      month: "Födelsemånad",
      day: "Födelsedag",
      nameSurname: "Namn och efternamn",
      dateOfBirth: "Födelsedatum",
      fillNumber: "Fyll nummer",
      workSheetName: "Ark1",
      attribute: "Attribut",
      externalId: "Externt ID",
    },
    csvFieldsValidationMessages: {
      dateOfBirth: "Födelsedatum måste vara i formatet yyyymmdd",
      attributeRequired: "{{attributes}} krävs",
      nameSurnameInvalid: "namnet är ogiltigt",
      roleInvalid: "Roll {{role}} är ogiltig",
      roleNotPermitted:
        "Du har inte behörighet att importera användare med rollen Principal",
    },
    usersOrganization: "{{name}} Användare",
    addUserButton: "Lägg till användare",
    about: "Om mig",
    user: {
      role: "Roll",
      email: "E-postadress",
      status: "Status",
      forcePassword: "Tvinga lösenord",
      attribute: "Attribut",
      forcePasswordDescription:
        "Om du väljer det här alternativet kommer användaren inte behöva logga in med sitt organisationskonto (SSO) utan kommer att välja ett eget lösenord i Allbry själv vid första inloggningen",
      attributeDescription:
        "Du kan välja ett till flera attribut. \n\nDet betyder att endast elever med minst ett av de valda attributen kan kommunicera med dig. Du kan fortfarande kommunicera med samtliga elever. \nOm du inte väljer några attribut kan alla elever se dig.\n",
      attributeSelectionTitle: "Ytterliggare information",
      attributeSelectionDescription:
        "Vi ber dig att fylla i uppgifterna nedan. Informationen används för att kunna anpassa vår kommunikation och är frivillig att lämna.",
      allbryCounsellor: "Allbry rådgivare",
      noAttributes:
        "Inga attribut hittades. Kontakta administratören för att lägga till attribut.",
      journalAccess: "Journalåtkomst",
      journalAccessDescription:
        "Du kan hantera journalåtkomst för användare här.",
      noJournalAccess: "Ingen journalåtkomst",
      journalAccessRequired: "Välj minst en journal.",
    },
    enterFieldName: "Ange fältnamn (t.ex. klass)",
    result: "{{value}} resultat",
    results: "{{value}} resultat",
    noResults: "Inga resultat",
    day: "Dag",
    month: "Månad",
    year: "År",
    statistic: {
      title: "Statistik",
      calendar: "Kalender",
      today: "Idag",
      last7Days: "Senaste 7 dagarna",
      last30Days: "Senaste 30 dagarna",
      last90Days: "Senaste 90 dagarna",
      thisWeek: "Vecka",
      thisMonth: "Månad",
      thisQuarter: "Kvartal",
      thisYear: "År",
      allTime: "Historiskt",
      userTypes: "Användartyper",
      notFound: "Ingen statistik hittades",
      topics: "Elevrapporter",
      amountOfReports: "Antal rapporter",
      experience: "Orosnivå",
      counselling: "Samtalsbokningar",
      popularTimes: "Populära tider",
      ngoClicks: "Stödlinjer",
      usersAmount: "{{amount}} användare",
      levelOfWorry: "Nivå av oro",
      chats: "Chattar",
      video: "Video",
      other: "Annat",
      appointments: "Samtal",
      all: "Alla",
      without0: "Faktisk oro",
      without0tooltip:
        "Aktiverad: Genomsnittlig orosnivå visas för de samtal där det faktiskt har angivits att det finns en oro. \nAvvaktiverad: Genomsnittlig orosnivå för alla samtal visas även där oro inte upplevts.",
      allTitle: {
        users: "{{value}} användare",
        user: "{{value}} användare",
        times: "{{value}} konversationer",
        time: "{{value}} konversation",
        redirection: "{{value}} hänvisningar",
        redirections: "{{value}} hänvisningar",
      },
      registered: "Registrerade",
      inactive: "Inaktiva",
      active: "Registrerade & aktiva",
      todayInterval: "Idag {{start}} - {{end}}",
      pdfExport: "Exportera som PDF",
      chartTitle: "Samtal",
      student: "Elevstatistik",
      internal: "Intern EHT statistik",
      totalHours: "Totalt antal timmar",
      showAll: "Visa allt",
      showLess: "Visa mindre",
      anonymousUsersCount: "Antal anonyma användare - {{count}}",
      selectTopicsCategories: "Välj ämneskategorier",
      includeMeetingKind: "Inkludera manuella rapporter",
      includingManualReports: "Inkluderar manuella rapporter",
      notIncludingManualReports: "Inkluderar inte manuella rapporter",
      moreThanOneChatCountAverage:
        "Genomsnittligt antal chattar för elever som chattat mer än en gång:",
      oneChatCountPercentage: "Antal elever som endast chattat en gång:",
    },
    internalStatistic: {
      time: "Tid per grupp",
      total: "Totalt",
      hours: "timmar",
    },
    changeAttributesNotes:
      '- Om du vill ändra attribut, välj och visa inmatningsrutan för att skriva din ändring, tryck sedan på "Spara"-knappen för att spara ändringarnarna. \n - Om du bara väljer attribut utan att fylla i ett nytt värde och trycker på "Spara"-knappen kommer du att radera attributet. \n - Om du vill lägga till ett nytt attribut, skriv ditt nya attribut och tryck sedan på "Spara"-knappen. ',
    requestOnboardingEmailSuccess:
      "Onboardingmejl har skickats till användarna",
  },
  admin: {
    title: "Allbry Admin",
    emailStatistics: {
      description: "Övervaka e-postleveranser från SMTP/Nodemailer-flödet.",
      from: "Från",
      to: "Till",
      invalidDate: "Slutdatum måste vara efter startdatum.",
      status: {
        label: "Status",
        placeholder: "Valfri status",
        all: "Alla statusar",
        sent: "Skickad",
        delivered: "Levererad",
        deferred: "Fördröjd",
        failed: "Misslyckad",
        rejected: "Avvisad",
        bounced: "Studsad",
      },
      template: {
        label: "Mall",
        placeholder: "t.ex. CHECK_IN_AVAILABLE",
      },
      limit: {
        label: "Gräns",
        placeholder: "Välj gräns",
      },
      topN: "Topp {{count}}",
      range: {
        last7: "Senaste 7 dagarna",
        last30: "Senaste 30 dagarna",
        last90: "Senaste 90 dagarna",
        last365: "Senaste 365 dagarna",
        allHistory: "Hela historiken",
      },
      apply: "Tillämpa filter",
      clear: "Rensa",
      fetchError: "Det går inte att ladda e-poststatistiken just nu.",
      charts: {
        daily: {
          title: "Daglig status per dag",
          subtitle: "Staplad yta med antal per status.",
        },
        failureRate: {
          title: "Felfrekvens per mall",
          subtitle: "Sorterad efter högsta felprocent.",
        },
        topTemplates: {
          title: "Toppmallar efter volym",
          subtitle: "Högst skickade mallar inom intervallet.",
        },
        statusByTemplate: {
          title: "Volym per status och mall",
          subtitle: "Staplade staplar per mall och status.",
        },
        errors: {
          title: "Vanligaste felmeddelanden",
          subtitle: "Normaliserade SMTP-fel och svar.",
        },
      },
      empty: {
        daily: "Ingen e-posttrafik för detta intervall.",
        failure: "Inga fel registrerade för detta intervall.",
        top: "Ingen mallvolym att visa.",
        statusByTemplate: "Ingen malluppdelning hittades.",
        errors: "Inga fel hittades för detta urval.",
      },
      table: {
        message: "Meddelande",
        total: "Totalt",
        errors: "Fel",
        smtpResponses: "SMTP-svar",
        unknownTemplate: "Okänd mall",
        unknownMessage: "Okänt meddelande",
        unknown: "Okänd",
      },
    },
    modals: {
      addCounsellors: {
        choose: "Välj elevhälsopersonal",
        search: "Sök elevhälsopersonal",
      },
    },
    organization: {
      cannotBeOwnParent: "En organisation kan inte vara sin egen överordnade",
      organizations: "organisationer",
      edit: "Redigera organisationen",
      details: "Uppgifter om organisationen",
      closed: "Stängt",
      start: "Startdatum",
      end: "Slutdatum",
      principal: "Huvudansvarig",
      principals: "Huvudmännen",
      create: "Skapa en organisationen",
      view: "Visa",
      editPopup: "Redigera",
      deactivated: "Organisationen inaktiverad",
      deactivatedError: "Fel vid avaktivering av organisationen",
      name: "Organisationens namn",
      startEnd: "Startdatum/Slutdatum",
      addPrincipal: "+ Lägg till huvudansvarig",
      addCounsellor: "+ Lägg till elevhälsopersonal",
      searchOrganizations: "Sök efter organisationer med namn",
      edited: "Organisationen redigerades framgångsrikt.",
      created: "Organisationen skapades framgångsrikt.",
      createdError: "Fel i att skapa en organisation",
      editError: "Fel i redigeringen av organisationen",
      longName: "För långt namn",
      startDateRequired: "Startdatum krävs",
      endBeforeStart: "Slutdatum kan inte vara före startdatum",
      longEmail: "För långt e-postadress",
      emailFormat: "Fel e-postformat",
      duplicateEmails: "Dubbla e-postmeddelanden",
      userExists: "Användaren finns redan",
      atLeastOne: "Minst en av dem måste vara aktiv.",
      subscriptionType: {
        title: "Subscription types",
        description:
          "Your organization  bla bla description for the feature allows you to be anonymous. Your name and profile image will be hidden from other users",
        addLink: "+ Add feature or type",
        selectType: "Select type",
        registrationCode: "Registration code",
        add: "Add",
        remove: "Remove",
        addDialogTitle: "Add subscription type",
        addSuccess: "Subscription type has been added successfully",
        removeSuccess: "Subscription type has been removed successfully",
      },
      deleteOrganization: "Ta bort organisation",
      requestScrapeSuccess: "Du har tagit bort organisationen",
      scrapeMultipleOrganizationDialogInstruction:
        "Du kommer att ta bort följande organisation",
    },
    role: {
      title: "Roller",
      addRoles: "+ Lägg till roll",
      createRole: "Skapa roll",
      editRole: "Ändra roll",
      chooseMasterRole: "Välj master roll",
      enterNameRoleSwedish: "Ange namn på roll svenska",
      enterNameRoleEnglish: "Ange namnet på rollen engelska",
      chooseFeatures: "Välj funktioner",
      selectMasterRole: "Välj master roll",
      selectBaseRoleFirst: "Välj en basroll först för att välja ett rollnamn.",
      customRolesCreated: "Rollen är skapad",
      errorCreateCustomRoles: "Fel vid skapandet av rollen",
      updatedCustomRoles: "Rollen är uppdaterad",
      errorUpdatingCustomRoles: "Fel vid uppdatering av rollen",
      removeCustomRoles: "Rollen är borttagen",
      errorRemovingCustomRoles: "Fel vid borttag av rollen",
      confirmRemoveCustomRoles:
        "Är du säker på att du vill ta bort den här rollen? Denna åtgärd kan inte ångras.",
      rolesRequired: "Roller är obligatoriskt",
      rolesSelectRequired: "Skapa minst en roll",
      chooseFeaturesOne: "Välj minst en funktion",
      sessionTimeRequired: "Sessionstid krävs",
      sessionTimeNumber: "Sessionstiden ska vara nummer",
      sessionTimeMin: "Sessionstiden bör vara längre än 1 timme",
      sessionTimeTitle: "Sessionstid",
      sessionTimeDescription:
        "Hur länge en elevs session är aktiv innan de behöver logga in igen.",
      sessionTime1Day: "1 dag",
      sessionTime7Days: "7 dagar",
      sessionTime30Days: "30 dagar",
      sessionTime1DayDesc: "Korttidsåtkomst",
      sessionTime7DaysDesc: "Veckovis åtkomst",
      sessionTime30DaysDesc: "Månadsvis åtkomst",
      createRoleSubtitle:
        "Konfigurera en ny roll med namn, funktioner och sessionstid",
      editRoleSubtitle:
        "Uppdatera rollens detaljer, funktioner och sessionstid",
      baseRoleSection: "Basroll",
      roleNameSection: "Rollnamn",
      noBaseRole: "Ingen basroll",
      featuresLabel: "Funktioner",
      noFeaturesSelected: "Inga funktioner valda",
      featuresSelectedCount: "{{count}} av {{total}} valda",
      featuresSelectedAll: "Alla {{count}} valda",
      selectAllFeatures: "Välj alla",
      clearAllFeatures: "Rensa alla",
      customRoleNameLabel: "+ Anpassad",
      customRoleNameDesc: "Ange eget rollnamn",
      roleNamePlaceholder: "Rollnamn...",
      readyToSave: "Redo att spara",
      sessionDurationTitle: "Inloggningstid",
      sessionDurationHelper:
        "Hur länge en användare är aktiv innan de behöver logga in igen.",
      allFeaturesWarning:
        "Alla behörigheter är valda. Granska åtkomst innan du sparar.",
      roleSummaryBase: "Basroll",
      roleSummaryRole: "Roll",
      roleSummaryFeatures: "Funktioner",
      roleSummarySession: "Session",
    },
    counsellors: {
      title: "Kurator i Allbry",
      add: "Lägg till kurator",
      edit: "Redigera kurator",
      profile: "Personalens profil",
      searchCounsellors: "Sök efter rådgivare med namn",
    },
    ftpDataCollection: {
      title: "FTP Data Collection",
      selectOrganizations: "Select Organization",
      runCron: "Run Now",
      cronRunStart:
        "Data migration process started for the selected organization. You will be received an email shortly",
    },
    configData: {
      title: "Config Data",
      addConfig: "Add Config",
      organization: "Organization",
      migrationTime: "Migration Time",
      status: "Status",
      active: "AKTIV",
      deactivate: "Deactivated",
      viewProfile: "View Config",
      editProfile: "Edit Config",
      organizationActivated: "Organization Activated",
      organizationDeactivated: "Organization Deactivated",
      activatingError: "Error activating Organization",
      deactivatingError: "Error deactivating Organization",
      configDetails: "{{organization}}'s Config Details",
      timerNotSet: "Timer Not Set",
      yes: "Yes",
      no: "No",
    },
    configForm: {
      title: "Config Form",
      addOrgConfig: "Add organization Config",
      editOrgConfig: "Edit organization Config",
      ftpConfigDetails: "FTP Config Details",
      organization: "Organization",
      runOnce: "Run Single Time",
      timer: "Timer",
      daily: "Every Midnight",
      weekly: "Every Sunday Midnight",
      monthly: "Every 1st Of Month Midnight",
      selectTimer: "Select Timer",
      subOrganization: "Sub Organization",
      addOrganization: "+ Add Organization",
      selectOrganizations: "Select Organization",
      userModel: "User Models",
      addModel: "+ Add Model",
      student: "Student",
      attribute: "Attribute",
      userAttributes: "User Attribute",
      addAttribute: "+ Add Attribute",
      selectAttributes: "Select Attribute",
      name: "Name",
      code: "Code",
      host: "Host Name",
      username: "Username",
      password: "Password",
      port: "Port",
      secure: "Secure",
      fileName: "File Name",
      fileFormat: "File Format",
      filePath: "File Path",
      true: "True",
      false: "False",
      fileNameEx: 'Ex: File name is "latest" or create \nyour custom file name',
      filePathEx: 'Ex: File path is "/"  ',
      userModelNameEx: 'Ex: name is "student/counsellor"',
      userModelCodeEx: 'Ex: code is "student/counsellor"',
      edit: "Edit Config",
      nameRequired: "Name is required",
      codeRequired: "Code is required",
      selectRequired: "Select any one",
      configRequired: "{{name}} is required",
    },
    notifications: {
      notificationDate: "Datum",
      title: "Notifikationer",
      message: "Meddelande",
      activeInactive: "Aktiv / Inaktiv",
      status: "Status",
      all: "Alla",
      sent: "Skickat",
      upcoming: "Kommande",
      vieweditNotifications: "Se / ändra notis",
      deleteNotifications: "Ta bort notis",
      createNotification: "Skapa notis",
      notificationDateAndTime: "Datum och tid",
      notificationMessage: "Meddelande",
      notificationMessagePlaceholder: "Ange ett aviseringsmeddeland",
      allOrganization: "Alla organisationer",
      selectOrganization: "Välj organisation",
      add: "Lägg till",
      popup: "Är du säker på att du vill ta bort notisen?",
      selectRequired: "Välj minst en organisation",
      messageValidation: "Meddelandet får inte vara tomt",
      createdNotification: "Notisen är skapad",
      removeNotification: "Notisen är borttagen",
      editNotification: "Notisen är ändrad",
      errorCreateNotification: "Fel vid skapandet av notisen",
      errorErrorNotification: "Fel vid ändring av notisen",
    },
    superActions: {
      title: "Super Actions",
      userLoginWithEmail: "Logga in med e-postadress",
      loginButton: "Logga in",
      emailInput: "E-postadress",
    },
    broadcastMessages: {
      createdBroadcastMessage: "Sändningsmeddelande skapades framgångsrikt",
      updatedBroadcastMessage: "Broadcast-meddelandet har uppdaterats",
      removedBroadcastMessage: "Broadcast-meddelandet har tagits bort",
      deleteBroadcastMessageConfirmation:
        "Är du säker på att du vill radera denna post?",
      deleteBroadcastMessageError:
        "Du kan inte radera denna post men kan avaktivera den",
      editBroadcastMessage: "Redigeringen av sändningsmeddelandet lyckades",
      errorCreateBroadcastMessage:
        "Ett fel uppstod när sändningsmeddelandet skapades",
      errorUpdateBroadcastMessage: "Fel vid uppdatering av sändningsmeddelande",
      errorRemoveBroadcastMessage:
        "Fel när sändningsmeddelandet skulle tas bort",
      allOrganizations: "Alla organisationer",
      selectOrganization: "Välj Organisation",
      active: "Aktiva",
      inActive: "Inaktiv",
      edit: "Redigera",
      delete: "Radera",
      create: {
        startDate: "Start datum",
        endDate: "Slutdatum",
        enterHeading: "Ange rubrik",
        message: "Ange meddelande",
        newsAndMarketingMessage: "Nyheter och marknadsföringsmeddelande",
        add: "Lägg till",
        heading: "Rubrik",
        userTypes: "Användartyper",
        selectUserTypes: "Välj Användartyp",
      },
      userTypes: {
        counsellor: "Rådgivare",
        student: "Studerande",
      },
      listingColumn: {
        heading: "Rubrik",
        message: "Meddelande",
        startDate: "Start datum",
        endDate: "Slutdatum",
        userType: "Användartyp",
        status: "Status",
      },
    },
  },
  allbryCounsellor: {
    choose: "Välj organisation",
    notFound: "Ingen organisation hittad...",
    text: "Du har inte lagts till i någon organisation ännu.",
    error: "Fel när du försöker logga in i organisationen",
  },
  filterModal: {
    filter: "Filter",
    addFilter: "Lägg till filter",
    description: "Visa användare som uppfyller alla villkor:",
    addCondition: "+ Lägg till fler",
    is: "är",
    isNot: "är inte",
    chooseFilter: "Välj filter",
    conditionValue: "Ange villkorets värde",
  },
  counsellorReport: {
    tabs: {
      reportTemplates: "Rapportmallar",
      reports: "Rapporter",
      customReports: "Anpassade rapporter",
    },
    reports: "Rapporter",
    reportTemplate: {
      studentReport: "Elevrapport",
      studentReportDescription: "Skapa en elevrapport",
      studentNote: "Minnesanteckning",
      studentNoteDescription: "Skapa en minnesanteckning om en elev",
      internalReport: "EHT rapport",
      internalReportDescription: "Skapa en intern EHT rapport",
      anonymousReport: "Anonym elevrapport",
      anonymousReportDescription: "Skapa en anonym elevrapport",
    },
    internalReport: {
      selectTypes: "2. Välj typ av möte",
      selectFilter: "3. Välj grupp om relevant (ej obligatorisk)",
      meetingDuration: "5. Mötets varaktighet (i timmar)",
      meetingNotes: "4. Skriv en kort sammanfattning av mötet",
      meetingNoteTitle: "Anteckningar",
      meetingTypes: {
        type1: "EHT",
        type2: "EHM",
        type3: "Samverkanssmöte SIP",
        type4: "Samverkansmöte med VH, skolpersonal med flera",
        type5: "Samverkanssmöte BUP",
        type6: "Samtal med VH, elever & annan aktör",
        type7: "Samtal med elev och VH",
        type8: "Samtal med VH",
        type9: "Samtal med elev och skolpersonal",
        type10: "Samtal med VH och annan aktör",
        type11: "Mötessamverkan",
        type12: "Närvaroarbete",
        type13: "Handledning av skolpersonal",
        type14: "Möte med skolpersonal",
        type15: "Möte med rektor",
        type16: "Medverkan i utvecklingsarbete",
        type17: "Medverkan i trygghetsarbete",
        type18: "Arbete med elevgrupp",
      },
      staticAttributes: {
        attributeName: {
          attribute1: "Stadie",
        },
        attributeValue: {
          attribute1value1: "Lågstadie",
          attribute1value2: "Mellanstadie",
          attribute1value3: "Högstadie",
          attribute1value4: "Gymnasie",
        },
      },
    },
    anonymousReport: {
      title: "Anonym elevrapport",
      selectAttributeTitle: "1. Välj klass/årskurs (valfritt)",
      noAttributes:
        "Inga attribut hittades. Kontakta din administratör för att lägga till attribut.",
      gender: "2. Könsidentitet (ej obligatoriskt)",
      studentName: "3. Ange elevens namn (ej obligatoriskt)",
    },
    chooseStudent: "Välj elev",
    chooseCustomStudent: "Välj {{label}}",
    noResultsFound: "Inga {{label}} hittades",
    createReport: "Skapa elevrapport",
    createNote: "Skapa minnesanteckning",
    searchStudents: "Sök efter elev",
    filterOption: {
      notes: "Anteckningar",
      quickReport: "Elevrapporter",
      internalReport: "Interna rapporter",
      anonymousReport: "Anonyma rapporter",
      customReport: "Anpassade rapporter",
      selectReport: "Välj rapporttyp",
    },
    attributeFilter: {
      filter: "Filter",
      title: "Filtrera efter attribut",
      search: "Sök attribut",
      noResults: "Inga matchande attribut hittades",
      selectAll: "Markera alla",
      selectAllValues: "Markera alla värden",
      clearAll: "Rensa alla",
    },
    showMore: "Visa mer...",
    uploadDocument: "Ladda upp dokument",
    noReports: "Inga rapporter tillgängliga",
    sortNewestFirst: "Senaste först",
    sortOldestFirst: "Äldsta först",
  },
  survey: {
    questionTypes: {
      comment: "Flerradigt svar",
    },
    introStep: "Hej, låt oss börja med två snabba frågor!",
    deleteSuccess: "Mallen har tagits bort",
    firstStep: {
      question: "Är det första gången du använder Allbry?",
      letMeIn: "Nej, jag har använt Allbry förut",
      whatIsAllbry: "Ja, det är första gången",
    },
    secondStep: {
      question: "Har du sökt stöd tidigare?",
      yes: "Ja, minst ett par gånger",
      never: "Nej, det har jag inte",
    },
    genderStep: {
      question: "Med vilket kön identifierar du dig mest?",
      male: "Man",
      female: "Kvinna",
      other: "Annat",
      private: "Vill inte svara",
    },
    outroStep: "Tack för din tid!",
    helpImprove: "Det kommer bara ta en minut och frågorna är helt anonyma!",
    firstPart: "1/2",
    secondPart: "2/2",
    page: "Sida",
    checkInAndSurvey: "Tempen",
    tabOption: {
      template: "Mallar",
      active: "Aktiva",
      statistics: "Statistik",
    },
    create: {
      title: "Skapa mall",
      name: "Namn",
      accessType: "Åtkomsttyp",
      accessTypeOptions: {
        global: "Global",
        local: "Lokal",
      },
      surveyType: "Undersökningstyp",
      surveyTypeOptions: {
        checkIn: "Check-in",
        survey: "Enkät",
      },
      isPublic: "är offentlig",
      isActive: "Är aktiv",
    },
    createConfig: {
      title: "Konfigurationsmallar",
      Survey: "Enkätmall",
      Account: "Organisation",
      attributes: "Attribut",
      select: "-Välj-",
      runsDay: "Kör varje dag",
      runsWeekly: "Kör varje",
      runsMonthly: "Kör varje {{date}}:e i månaden",
      timerOption: {
        daily: "Dagligen",
        weekly: "Varje vecka",
        monthly: "En gång i månaden",
        weekDays: {
          monday: "Måndag",
          tuesday: "Tisdag",
          wednesday: "Onsdag",
          thursday: "Torsdag",
          friday: "Fredag",
          saturday: "Lördag",
          sunday: "Söndag",
        },
      },
      modals: {
        students: {
          title: "Eget urval",
          chooseStudentTitle: "Vilka vill du ta tempen på?",
          selectedStudents: "Valda elever",
          confirmSelection: "Bekräfta urval",
          searchPlaceholder: "Sök efter elev",
          noStudentsFound: "Inga elever hittades",
        },
      },
      addOwnUsers: "+ Lägg till dina egna användare",
      addedOwnUsers: "Lade till {{count}} egna användare",
    },
    template: {
      createTemplate: "Mall skapades",
      errorCreateTemplate: "Fel när mallen skapades",
      deleteTemplate: "Mallen har tagits bort",
      deleteTemplateConfirmation:
        "Är du säker på att du vill ta bort denna mall ?",
      deleteTemplateError:
        "Du kan inte ta bort den här mallen men kan avaktivera den",
      deleteConfigError:
        "Du kan inte ta bort den här konfigurationen men kan avaktivera den",
      errorDeleteTemplate: "Fel vid borttagning av mall",
      editTemplate: "Mallredigering lyckades",
      errorEditTemplate: "Fel vid redigering av mall",
      createConfig: "Tempen skapades framgångsrikt",
      errorCreateConfig: "Fel när konfigurationen skapades",
      active: "aktiva",
      inActive: "inaktiv",
      true: "Sann",
      false: "falsk",
      timer: "Timer",
      RunOnce: "Kör en gång",
      StartTime: "Starttid",
      EndTime: "Sluttid",
      TimeLimitInHour: "Tidsgräns i timme",
      editTemplate: "Mallredigering lyckades",
      errorEditTemplate: "Fel vid redigering av mall",
      typeChangeDescription:
        "Vi ser att du har några ändringar på undersökningsmallar.\n Är du säker på att du vill ändra?\n Om du ändrar undersökningstyp kommer alla ändringar att ignoreras.",
      active: "aktiva",
      inActive: "inaktiv",
      btn: {
        delete: "Ta bort",
        edit: "Redigera",
        statistics: "Statistik",
        addImage: "Bild till frågan",
      },
      listingColumn: {
        name: "Namn",
        accessType: "Åtkomsttyp",
        surveyType: "Undersökningstyp",
        public: "Offentlig",
        questionAmount: "Frågebelopp",
        status: "Status",
        attributes: "Användarattribut",
        organization: "organisations namn",
        isAnonymous: "är anonym",
        action: "Handling",
        StartDate: "Start datum",
        EndDate: "Slutdatum",
      },
      questionType: {
        filling: "Allbry",
        rangSlider: "Skjutreglage",
        singleSelect: "Enstaka val",
        image: "Bild",
      },
      createTemplateAboutDescription:
        "Se videon nedan för instruktioner om hur du skapar en mall",
      templateVideoLink: "Länk till mallinstruktionsvideo",
      createTemplateAboutTitle: "Beskrivning",
      duplicate: "Duplicera",
      copyText: "Kopiera",
      addImages: "Lägg till bilder",
    },
    student: {
      question: "Fråga",
      stripMas: "Din skola vill ta tempen!!",
      questionnaire: "Enkät",
      completeHeading: "Tack för dina svar!",
      completeDescription: "Enkäten har skickats in.",
      completeBackButton: "Tillbaka till hemskärmen",
      startSurvey: "Påbörja enkäten",
      skipQuestion: "Jag vill inte svara",
      SkipMas: "Är du säker på att du inte vill svara?",
      notAnonymousAnswerDescription:
        "Enkäten är inte anonym och elevhälsan kan ta del av individuella svar",
    },
    statistics: {
      noAnyTemplate: "Du har inga mallar",
      all: "Alla",
      ended: "Avslutad",
      started: "Startad",
      date: "Datum",
      lastFillUpDate: "Senaste ifyllnadsdatum",
      no: "Nr",
      name: "Namn",
      individualResponse: "Individuellt svar",
      AmountOfAnswers: "Antal svar",
      noOFUsers: "Antal elever",
      question: "frågor",
      thisMonth: "Denna månad",
      unanswered: "Obesvarad",
      status: {
        new: "Ny",
        complete: "Avslutad",
        active: "Aktiv",
      },
      showAll: "Visa allt",
      showLess: "Visa mindre",
      response: "svar",
      days: "dagar",
      weekNumbers: "Veckans nummer",
      months: "månader",
      students: "Elever",
      noAnyoneAnswered: "Inga elever har besvarat denna enkät än",
      answer: "Svar",
      deepFilter: "Djupfiltrering",
      averageValue: "Medelvärde: {{value}}",
      multiple: "(Flera olika)",
      guestUserLink: "Gästanvändarlänk",
      showGuestUserData: "Visa gästanvändardata",
      guestUsers: "gästanvändare",
      filterInfo: "Om ett filter tillämpas så visas inte gästanvändardata",
      showGuestUserDataDisabledContent:
        "Det går inte att visa gästanvändardata om ett filter tillämpas.",
      amountOfCustomStudents: "Manuellt valda elever",
      numberOfCustomStudents: "Antal manuellt valda elever",
      anonymousResponse: "Svar #{{number}}",
      responses: "Svar",
      students: "Elever",
      noAnyoneAnswered: "Ingen har svarat än",
      otherAnswers: "Annat svar",
      page: "Sida",
      searchStudents: "Sök elever",
      noSearchResults: "Inga elever matchar din sökning",
    },
    counsellor: {
      titles: { survey: "Enkät", checkIn: "Check-in" },
      readMoreDifferenceModalTitle: "Skillnad",
      checkInDescription:
        "En återkommande enkät med frågor som ställs med jämna mellanrum enligt valt tidsintervall. Den används för att kontinuerligt samla in data, identifiera trender och följa förändringar över tid. Perfekt för att mäta elevernas välmående eller andra faktorer som kräver regelbunden uppföljning. Genom att analysera resultaten över tid kan insikter skapas som bidrar till bättre beslutsfattande och långsiktig utveckling.",
      surveyDescription:
        "En engångsenkät med frågor som ställs vid ett specifikt tillfälle. Den används för att snabbt samla in information, utvärdera en händelse eller få en ögonblicksbild av elevernas åsikter och upplevelser. Passar bra för trygghets- och trviselenkäter, skolenkäter eller utvärderingar där en enda datainsamling är tillräcklig. Resultaten kan ge värdefulla insikter för att fatta beslut eller förbättra framtida processer.",
      title: "Temperaturkollen",
      startTitle: "Ta tempen på dina elever",
      startDescription:
        "Med temperaturkollen kan du skicka ut långa eller korta frågeformulär för att lära dig mer om dina elevers välmående.",
      createTemplateBtn: "Skapa din första temp",
      addTemplateBtn: "Skapa ny temp",
      readMoreDifference: "Läs mer om skillnaden",
      student: "elever",
      ownSelection: "Eget urval",
      ownSelectionDescription: "Välj enskilda personer",
      answered: "Svarade",
      dispatch: "Utskicksfrekvens",
      adjustTime: "Anpassa datum och tid",
      question: {
        num1: "Vill du ta tempen eller skapa en enkät?",
        template: "Vad vill du ta tempen på?",
        attribute: "Vilka vill du ta tempen på?",
        selectedAttribute: "Vald attribut",

        survey: "När vill du skicka ut enkäten?",
        checkIn: "Hur ofta vill du ta tempen?",
        description: {
          checkIn:
            "En återkommande enkät med frågor som ställs med jämna mellanrum enligt valt tidsintervall",
          survey:
            "En engångsenkät med frågor som ställs vid ett specifikt tillfälle",
        },
        anonymousPageTitle: "Vill du se individuella svar?",
        anonymousPageDescription:
          "Om du aktiverar detta så kommer du att kunna se elevernas individuella svar, dock kommer eleverna att informeras när enkäten startar att deras svar inte kommer att vara anonyma.",
        guestPageTitle: "Vill du skapa en enkätlänk?",
        guestPageDescription:
          "Om du aktiverar detta får du en länk och/eller QR-kod som du kan dela ut till elever, vårdnadshavare eller andra som INTE har Allbry. \n Personerna som sedan använder länken kommer att kunna svara på enkäten utan att logga in och/eller ha ett konto. Funktionen går att kombinera med klasser/årskurse samt att se individuella svar för dessa.",
        info: "Info",
        infoDescription:
          "Denna undersökning innehåller för närvarande en fråga om filuppladdning. Eftersom gästanvändare inte har tillåtelse att ladda upp filer, vänligen ta bort frågan om filuppladdning innan du delar undersökningen med gästanvändare.",
      },
      status: {
        active: "Aktiva",
        search: "Sök",
        completed: "Avslutade",
      },
      timerOption: {
        daily: "Dagligen",
        weekly: "Veckovis",
        monthly: "Månadsvis",
        dailyDescription: "Skickas varje dag",
        weeklyDescription: "Skickas varje måndag",
        monthlyDescription: "Skickas den 1a varje månad",
      },
      createOwnTemplate: "+ Skapa en egen mall",
    },
    templateType: {
      general: "Allmänna",
      private: "Egna",
    },
    surveyTypeOptions: {
      checkIn: "Check-in",
      survey: "Enkät",
    },
    amountQuestion: "Antal frågor",
    numberOfQuestion: "Antal frågor",
    endSurveyConfig: "Avsluta enkäten",
    endSurveyPopupConfirmationText: "Är du säker på att du vill avsluta?",
    endSuccess: "Enkäten har avslutats",
    deleteSurveyConfig: "Ta bort enkät",
    deleteSurveyConfigPopupConfirmationText:
      "Är du säker på att du vill ta bort enkäten och enkätsvaren?",
    deleteSurveyConfigPopupConfirmationBody:
      "Observera att även enkätsvaren kommer att försvinna, åtgärden kan inte ångras.",
    editorLabels: {
      designer: "Redigera",
      preview: "Förhandsgranska",
    },
    maxFileSizeError: "Den maximala filstorleken är {{size}} MB",
  },
  customReports: {
    title: "Anpassade rapporter",
    description:
      "Här kan du välja att aktivera och/eller skapa egna rapportmallar om du saknar något i våra existerande. På samma sätt som med elevrapporten så generaras grafer och statistik utifrån de svar som personalen har gett. Du kan även välja att skapa en anonym rapport där ingen av elevernas svar går att spåra tillbaka till dem.",
    createReportBtn: "Skapa en anpassad rapport",
    reminderScreen: {
      skip: "Hoppa över",
      continue: "Fortsätt",
      title: "Rubrik",
      titlePlaceholder: "Vänligen ange en text som kommer visas i påminnelsen",
      titleTooLong: "Rubriken får inte vara längre än {{max}} tecken.",
      question: "Vill du ställa in en påminnelse?",
      selectDueDate: "Välj förfallodatum",
      description:
        "Påminnelsen skickas till dig och de taggade kollegorna på valt datum. Du hittar alla dina påminnelser under fliken Aktiviteter på startsidan.",
    },
    journalAccessScreen: {
      description: "Var vill du skapa rapporten?",
      chooseJournal: "Välj journal",
    },
    template: {
      title: "Skapa mall",
      type: {
        general: "Allmän",
        private: "Egna",
      },
      duplicate: "Duplicera",
      copyText: "Kopiera",
      name: "Namn",
      namePlaceholder: "Vänligen ange namn",
      description: "Beskrivning",
      descriptionPlaceholder: "Vänligen ange beskrivning",
      accessTypeLabel: "Åtkomsttyp",
      accessTypePlaceholder: "Välj åtkomsttyp",
      accessType: {
        global: "Global",
        local: "Lokal",
      },
      public: "Offentlig",
      active: "Aktiv",
      createTemplateAboutTitle: "Beskrivning",
      createTemplateAboutDescription:
        "Se videon nedan för instruktioner om hur du skapar en mall",
      templateVideoLink: "Länk till mallinstruktionsvideo",
      createTemplateSuccess: "Mall skapades framgångsrikt",
      errorCreateTemplate: "Fel när mallen skapades",
      updateTemplateSuccess: "Mallredigering lyckades",
      errorUpdateTemplate: "Fel vid redigering av mall",
      deleteTemplateConfirmation:
        "Är du säker på att du vill ta bort denna mall?",
      createTemplateSecretLevelConfirmationLow:
        "Är du säker på att du vill aktivera rapporten med låg sekretessnivå?",
      createTemplateSecretLevelConfirmationHigh:
        "Är du säker på att du vill aktivera rapporten med hög sekretessnivå?",
      createTemplateSecretLevelDescription:
        "Följande roller kommer att ha tillgång till rapporttypen: {{description}}",
      deleteTemplateSuccess: "Mallen har tagits bort",
      errorDeleteTemplate: "Fel vid borttagning av mall",
      confirmDialog: {
        editTemplate: {
          header: "Är du säker på att du vill redigera den här mallen?",
          body: "Om du redigerar mallen påverkas alla rapporttyper som använder den, inklusive redan skapade rapporter.",
        },
      },
    },
    information: "Information",
    taggedInformation:
      "Du kan välja att tagga en kollega i rapporten. Den personen kommer att få en notis om att du har skapat en rapport.",
    statistics: {
      selectTemplate: "Fler rapporttyper",
      users: "Användare",
      allReports: " Alla rapporter",
      normalReport: "Normal rapport #{{number}}",
      anonymousReport: "Anonym rapport #{{number}}",
      resultAdditionalInfo: {
        dateAndTime: "Datum och tid",
        user: "Användare",
        reporter: "Rapportör",
        counsellor: "Rådgivare",
        goToReport: "Gå till rapport",
      },
    },
    config: {
      screen1: {
        title: "Välj mall eller skapa egen",
        createTemplate: "Skapa din egen mall",
      },
      screen2: {
        title: "Roller med åtkomst- och sekretessnivå",
        person: "{{count}} person",
        persons: "{{count}} personer",
      },
      screen3: {
        title: "Vill du tillåta anonyma rapporter?",
        allowAnonymousReportsDescription:
          "Om du aktiverar detta kommer användare att kunna skapa anonyma rapporter. Med det menas att personalen inte behöver markera en elev när den använder rapporten.",
      },
      screen4: {
        title: "Välj sekretessnivå",
        high: "Hög",
        low: "Låg",
        allowPriorityDescription:
          "Ni behöver välja sekretessnivå för rapporttypen ni skapat. Valet av sekretessnivå avgör hur rapporter kan delas inom personalgruppen. <br><br> En hög sekretessnivå begränsar åtkomsten till individuella elevsvar och visar endast anonymiserad statistik för yrkesroller som inte valts specifikt. Fritextsvar döljs helt, då dessa kan innehålla identifierande information. Denna nivå passar när endast särskilt ansvariga professioner ska hantera känsliga uppgifter. <br><br> En låg sekretessnivå innebär att hela personalgruppen får tillgång till fullständiga rapporter, inklusive individuella svar och elevnamn. Även fritextsvar visas, vilket ger större transparens men också kräver noggrannhet i hanteringen av personuppgifter.",
        highPriorityDescription:
          "En hög sekretessnivå innebär att enskilda rapporter inte är synliga för all personal. Endast de yrkesroller som valdes i föregående steg får tillgång till individuella svar. Övrig personal kan endast ta del av sammanställd statistik, och då utan koppling till enskilda elever. Dessutom visas ingen statistik från fritextsvar, eftersom dessa kan innehålla uppgifter som kan identifiera en elev.",
        lowPriorityDescription:
          "En låg sekretessnivå innebär att all personal får tillgång till individuella svar i rapporterna, inklusive information om vilka elever rapporterna gäller. Det innebär att inga begränsningar sätts på vilka yrkesroller som får se innehållet. Även fritextsvar blir synliga, vilket kan innebära att personligt identifierbara uppgifter förekommer. Denna nivå kan vara lämplig i sammanhang där ett helt team behöver full insyn för att kunna ge rätt stöd.",
      },
      screen5: {
        title: "Vill du tillåta påminnelser för denna rapport?",
        allowReminderDescription:
          "Om du aktiverar detta kommer användare att kunna ställa in påminnelser för denna rapport. Detta innebär att personalen kommer att få aviseringar enligt påminnelseinställningarna.",
      },
      createSuccess: "Rapporten har skapats",
      errorCreateConfig: "Fel när rapporten skapades",
      updateSuccess: "Rapporten har uppdaterats",
      errorUpdateConfig: "Fel vid uppdatering av rapport",
      list: {
        all: "Alla",
        reports: "{{count}} Rapporter",
      },
      amountOfQuestions: "Antal frågor",
      amountOfReports: "Antal rapporter",
      roles: "Roller",
      editRoles: "Redigera",
      editTemplate: "Redigera mall",
      rolesUpdateSuccess: "CustomReport har uppdaterats",
      errorRolesUpdate: "Fel vid uppdatering av CustomReport",
      secretLevel: "Sekretessnivå",
      secretLevelValues: {
        HIGH: "Hög",
        LOW: "Låg",
      },
      areYouSure: "Är du säker på att du vill redigera sekretessnivån?",
      warningDialogForNotEligibleToEditTemplate: {
        header: "Du kan inte redigera den här mallen",
        body: "Du kan inte redigera den här mallen eftersom du inte är berättigad att redigera den här mallen. Kontakta din administratör.",
      },
      restrictionDialogForNotEligibleToEditTemplate: {
        header: "Begränsad åtkomst",
        body: "Du kan inte redigera den här mallen eftersom den är generell. Om du vill göra ändringar behöver du först duplicera mallen och sedan redigera den nya mallen.",
      },
    },
    downloadPDF: "Ladda ner PDF",
    pdf: {
      report: "Rapport",
      question: "Fråga",
      dateAndTime: "Datum och tid",
      user: "Användare",
      reporter: "Rapportör",
      counsellors: "Personal",
      noAnswer: "Inget svar",
      openInNewTabHint: "Tips: Högerklicka på länken och öppna i en ny flik.",
      page: "Sida",
      signedBy: "Signerad av",
    },
    reasonForChange: "Anledning till ändring",
    reasonForChangePlaceholder: "Ange anledningen till ändringen",
    changelog: "Ändringslogg",
    changeItem: "Ändring #{{number}}",
    changeBy: "{{dateAndTime}} av {{user}}",
    signatureStatus: {
      draft: "Utkast",
      signed: "Signerad",
    },
    signReport: {
      title: "Signera rapport",
      description:
        "Genom att signera låser du rapporten. Inga ändringar kan göras utan att låsa upp den först.",
      confirmLabel: "Bekräfta med ditt namn",
      confirm: "Signera",
      cancel: "Avbryt",
      nameMismatch: "Namnet matchar inte ditt användarnamn",
    },
    unlockReport: {
      title: "Lås upp rapport",
      description:
        "Rapporten kommer att låsas upp för redigering. Händelsen loggas i eventloggen.",
      signedBy: "Signerades av",
      reasonLabel: "Anledning till upplåsning",
      reasonPlaceholder: "Ange anledning",
      confirm: "Lås upp",
      cancel: "Avbryt",
    },
    viewOtherReport: {
      title: "Visa anpassad rapport",
      description:
        "Den här rapporten skapades av en annan användare. Vill du fortsätta visa den?",
      cancel: "Avbryt",
      continue: "Fortsätt",
    },
    eventLog: "Eventlogg",
    eventLog_report_viewed: "Rapport visad",
    eventLog_report_exported: "Rapport exporterad",
    eventLog_report_signed: "Rapport signerad",
    eventLog_report_unlocked: "Rapport upplåst",
    eventLog_report_updated: "Rapport uppdaterad",
    eventLog_report_updated_draft: "Rapport uppdaterad (utkast)",
    eventLog_report_removed: "Rapport borttagen",
    signReport_btn: "Signera rapport",
    unlockReport_btn: "Lås upp",
    cannotDelete: "Rapport kan inte tas bort efter att den signerats",
    allowGuestEditing: "Tillåt gästredigering",
    allowGuestEditingEnableQuestion:
      "Är du säker på att du vill tillåta andra kuratorer att redigera denna rapport?",
    allowGuestEditingDisableQuestion:
      "Är du säker på att du vill inaktivera gästredigering för denna rapport?",
    allowGuestEditingYesEnable: "Ja, tillåt",
    allowGuestEditingYesDisable: "Ja, inaktivera",
    allowGuestEditingEnabled: "Gästredigering har aktiverats",
    allowGuestEditingDisabled: "Gästredigering har inaktiverats",
  },
  contact: {
    title: "Kontaktkort",
    addNew: "Lägg till kontakt",
    edit: "Redigera kontakt",
    editSubtitle: "Uppdatera kontaktinformation och relationsinställningar.",
    firstName: "Förnamn",
    lastName: "Efternamn",
    personalNumber: "Personnummer",
    address: "Adress",
    phoneMobile: "Telefon",
    phoneWork: "Telefon arbete",
    email: "E-post",
    notes: "Anteckning",
    notesPlaceholder: "Lägg till ytterligare information om denna kontakt...",
    relation: "Relation till eleven",
    legalGuardian: "Juridisk vårdnadshavare",
    legalGuardianShort: "VH",
    legalGuardianHelper: "Kan fatta juridiska beslut för eleven.",
    streetAddress: "Gatuadress",
    streetAddressPlaceholder: "Börja skriva för att söka efter en adress...",
    addressSearching: "Söker adresser...",
    postalCode: "Postnummer",
    city: "Stad",
    country: "Land",
    dateOfBirth: "Födelsedatum",
    genderIdentity: "Kön",
    genderPlaceholder: "Välj kön",
    validation: {
      studentGuardian: "En elev kan inte utses till sin egen vårdnadshavare.",
      invalidPersonalNumber:
        "Ange ett giltigt personnummer (t.ex. YYYYMMDD-XXXX)",
      invalidPhone:
        "Ange ett giltigt telefonnummer (7-30 tecken: siffror, mellanslag, +, -, ())",
      invalidPostalCode: "Ange ett giltigt postnummer för det valda landet",
      studentAlreadyExists:
        "En elevkontakt finns redan. Endast en elev per person är tillåten.",
      studentRelationLocked:
        "Relationstypen Elev kan inte ändras när den väl är inställd.",
    },
    primaryContact: "Primär kontakt",
    primaryBadge: "Primär",
    primaryContactHelper: "Kontakta denna person först vid behov.",
    primaryContactWillReplace: "Detta ersätter {{name}} som primär kontakt.",
    settings: "Kontaktinställningar",
    call: "Ring",
    sendEmail: "Skicka e-post",
    delete: "Ta bort",
    personalId: "Personnummer",
    deleteConfirmTitle: "Ta bort kontakt?",
    deleteConfirmMessage:
      "Är du säker på att du vill ta bort {{name}}? Åtgärden kan inte ångras.",
    confirmDelete: "Ta bort",
    deletedSuccessfully: "Kontakten togs bort.",
    primaryContactUpdated: "Primär kontakt uppdaterad.",
    viewDetails: "Visa detaljer",
    makePrimary: "Gör till primär",
    makePrimaryConfirmTitle: "Gör till primär kontakt?",
    moreOptions: "Fler alternativ",
    save: "Spara",
    saveChanges: "Spara ändringar",
    cancel: "Avbryt",
    noContacts: "Inga kontaktkort tillagda ännu",
    noContactsHint:
      "Lägg till förälder, vårdnadshavare, syskon eller annan kontakt för den här eleven.",
    noContactInfo: "Ingen kontaktinfo",
    discardTitle: "Ignorera ändringar?",
    discardMessage:
      "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
    continueEditing: "Fortsätt redigera",
    discardChanges: "Ignorera ändringar",
    relationType: {
      student: "Student",
      parent: "Förälder",
      guardian: "Vårdnadshavare",
      sibling: "Syskon",
      relative: "Anhörig",
      foster_parent: "Familjehem",
      case_worker: "Handläggare",
      other: "Annan",
    },
    protected: "Skyddad",
    revealedBadge: "Visad",
    protectedSection: "Sekretess",
    protectedToggle: "Skyddade personuppgifter",
    protectedToggleHelper: "Uppgifter döljs och åtkomst loggas",
    viewProtectedData: "Visa uppgifter – åtkomsten loggas",
    confirmViewTitle: "Visa skyddade uppgifter?",
    confirmViewContactMessage:
      "{{name}} har skyddade personuppgifter. Din åtkomst loggas i händelseloggen med namn och tidpunkt.",
    confirmViewContactMessageSuffix:
      "har skyddade personuppgifter. Din åtkomst loggas i händelseloggen med namn och tidpunkt.",
    confirmViewStudentMessage:
      "Den här eleven har skyddade personuppgifter. Om du väljer att visa uppgifterna loggas din åtkomst i händelseloggen med namn och tidpunkt.",
    confirmEditTitle: "Redigera skyddade uppgifter?",
    confirmEditContactMessageSuffix:
      "har skyddade personuppgifter. Din åtkomst loggas i händelseloggen med namn och tidpunkt innan redigering.",
    viewAndLog: "Visa och logga åtkomst",
    editAndLog: "Redigera och logga åtkomst",
    protectedDataBadge: "Skyddade uppgifter",
    protectedBannerActiveTitle: "Skyddade personuppgifter",
    protectedBannerActiveDesc: "Uppgifterna visas. Åtkomsten är loggad.",
    protectedBannerInactiveTitle: "Skyddade personuppgifter",
    protectedBannerInactiveDesc:
      "Personuppgifterna är skyddade. Endast förnamn visas.",
    showProtectedData: "Visa uppgifter",
    dismissBanner: "Uppåt",
    protectedCount: "{{count}} skyddad",
    eventLog: "Händelselogg",
    eventLogTriggerHint: "Visa åtkomsthistorik",
    eventLogSubtitle: "Åtkomst till skyddade personuppgifter",
    eventLogTotal: "Totala händelser",
    eventLogProfileEvents: "Elevvisningar",
    eventLogContactEvents: "Kortspecifika händelser",
    eventLogMarkerEvents: "Elevmarkeringar",
    eventLogHearingScreeningEvents: "Hörselscreening",
    eventLogVisionScreeningEvents: "Synscreening",
    eventLogGrowthMeasurementEvents: "Tillväxtmätning",
    eventLogReferralEvents: "Remisser",
    eventLogTargetProfile: "Profilmål",
    eventLogTargetCard: "Kortmål",
    eventLogTargetUnknown: "Mål",
    eventLogStudentProfile: "Elevprofil",
    eventLogStudentCard: "Elevkort",
    eventLogContactCard: "Kontaktkort",
    eventLogDeletedContact: "Kontakt finns inte längre",
    eventLogDeletedContactCard: "Borttaget kontaktkort",
    eventLogMarkerCard: "Elevmarkering",
    eventLogHearingScreeningCard: "Hörselscreening",
    eventLogVisionScreeningCard: "Synscreening",
    eventLogGrowthMeasurementCard: "Tillväxtmätning",
    eventLogReferralCard: "Remiss",
    eventLogMarkerVisibleToLabel: "Synlig för",
    eventLogMarkerValidityLabel: "Giltighetstid",
    eventLogMarkerValidityRange: "Från {{from}} till {{until}}",
    eventLogMarkerValidFrom: "Giltig från {{from}}",
    eventLogMarkerValidUntil: "Giltig till {{until}}",
    eventLogNoFilterMatches: "Inga händelser matchar det här filtret.",
    eventLogClearFilter: "Rensa filter",
    eventLogBy: "Av {{name}}",
    viewedProtectedData: "Visade skyddade personuppgifter",
    gdprNote: "Loggen sparas i 5 år enligt GDPR och får inte raderas.",
    noLogEntries: "Inga åtkomsthändelser loggade ännu.",
    eventType: {
      viewProtectedStudent: "Visade skyddade elevuppgifter",
      viewProtectedContact: "Visade skyddade kontaktuppgifter",
      activateProtection: "Aktiverade identitetsskydd",
      deactivateProtection: "Inaktiverade identitetsskydd",
      addContact: "Lade till kontakt",
      editContact: "Redigerade kontakt",
      deleteContact: "Raderade kontakt",
      addStudentMarker: "Lade till elevmarkering",
      editStudentMarker: "Redigerade elevmarkering",
      archiveStudentMarker: "Arkiverade elevmarkering",
      createHearingScreening: "Lade till hörselscreening",
      updateHearingScreeningDraft: "Uppdaterade hörselscreening (utkast)",
      signHearingScreening: "Signerade hörselscreening",
      unlockHearingScreening: "Låste upp hörselscreening",
      updateHearingScreeningFinalAssessment:
        "Uppdaterade bedömning för hörselscreening",
      removeHearingScreening: "Tog bort hörselscreening",
      exportHearingScreening: "Exporterade hörselscreening",
      createVisionScreening: "Lade till synscreening",
      updateVisionScreeningDraft: "Uppdaterade synscreening (utkast)",
      signVisionScreening: "Signerade synscreening",
      unlockVisionScreening: "Låste upp synscreening",
      updateVisionScreeningFinalAssessment:
        "Uppdaterade bedömning för synscreening",
      removeVisionScreening: "Tog bort synscreening",
      exportVisionScreening: "Exporterade synscreening",
      createGrowthMeasurement: "Lade till tillväxtmätning",
      updateGrowthMeasurementDraft: "Uppdaterade tillväxtmätning (utkast)",
      signGrowthMeasurement: "Signerade tillväxtmätning",
      unlockGrowthMeasurement: "Låste upp tillväxtmätning",
      removeGrowthMeasurement: "Tog bort tillväxtmätning",
      exportGrowthMeasurement: "Exporterade tillväxtmätning",
      createReferral: "Skapade remiss",
      updateReferralDraft: "Uppdaterade remissutkast",
      signReferral: "Signerade remiss",
      unlockReferral: "Låste upp remiss",
      sendReferral: "Markerade remiss som skickad",
      receiveReferralResponseUploaded: "Laddade upp remissvar",
      receiveReferralResponseRegistered: "Registrerade remissvar",
      closeReferral: "Avslutade remiss",
      cancelReferral: "Makulerade remiss",
      removeReferral: "Tog bort remissutkast",
      exportReferral: "Laddade ner remiss-PDF",
      unknown: "Okänd händelse",
    },
  },
  growthMeasurement: {
    sectionTitle: "Tillväxt",
    registerMeasurement: "Registrera mätning",
    export: "Exportera",
    noMeasurements: "Inga tillväxtmätningar har registrerats än.",
    table: {
      date: "Datum",
      height: "Längd",
      weight: "Vikt",
      bmi: "BMI",
      type: "Typ",
      status: "Status",
      by: "Av",
    },
    pdf: {
      exported: "Exporterad",
      measurementsSection: "Mätningar",
      totalMeasurements: "Antal mätningar",
      latestHeight: "Senaste längd",
      latestWeight: "Senaste vikt",
      latestBmi: "Senaste BMI",
      puberty: {
        sectionTitle: "Pubertetsbedömning",
        hint: "Tanner-stadier anges I–V. Testikelvolym i ml.",
        none: "Ingen pubertetsbedömning har registrerats.",
        breast: "Tanner bröst",
        genital: "Tanner genitalier",
        pubicHair: "Tanner pubes",
        testicularLeft: "Testikel vänster",
        testicularRight: "Testikel höger",
        menarche: "Menarke",
      },
      chart: {
        titleHeightWeight: "Tillväxtkurva – längd och vikt",
        titleBmi: "Tillväxtkurva – BMI",
        ageAtExport: "Ålder vid export: {{age}}",
        reference: "Referens: {{reference}}",
        legendTitle: "Teckenförklaring",
        legend: {
          leftAxis: "vänster axel",
          rightAxis: "höger axel",
          median: "0 SD – medelvärde",
          trend: "Förlopp mellan mätningar",
          currentAge: "Ålder vid export",
        },
        explanationHeightWeight:
          "Kurvorna visar referensvärden för längd och vikt i förhållande till ålder: medelvärdet (0 SD) samt ±1, ±2 och ±3 standardavvikelser (SD). Punkterna är elevens registrerade mätningar, placerade efter elevens exakta ålder vid mättillfället. Längd avläses mot vänster axel och vikt mot höger axel.",
        explanationBmi:
          "Kurvorna visar referensvärden för BMI i förhållande till ålder: medelvärdet (0 SD) samt ±1, ±2 och ±3 standardavvikelser (SD). Punkterna är elevens registrerade BMI, placerade efter elevens exakta ålder vid mättillfället.",
        parents: "Biologisk mor: {{mother}}   ·   Biologisk far: {{father}}",
        midParentalHeight:
          "Målängd (MPH): {{value}} cm (föräldrarnas medellängd ± 6,5 cm beroende på kön)",
        disclaimer:
          "Kurvorna är avsedda för visuell bedömning. Exporten innehåller inga beräknade SDS-värden eller percentiler.",
        source: "Källa",
        notAvailableSex:
          "Tillväxtkurva har inte tagits fram eftersom elevens kön inte är angivet som Man eller Kvinna.",
        notAvailable: "Tillväxtkurvan kunde inte tas med i exporten.",
      },
    },
    measurementType: {
      routine: "Rutin",
      followUp: "Uppföljning",
      extraCheck: "Extra kontroll",
      imported: "Importerad",
    },
    bmiGauge: {
      title: "BMI",
      autoCalculated: "BMI beräknas automatiskt",
      fillHeightAndWeight: "Fyll i längd och vikt",
      disclaimer:
        "Denna BMI-beräkning avser vuxna. För barn och ungdomar bör BMI istället bedömas utifrån ålder och kön.",
      shortLabel: {
        severeUnderweight: "Svår",
        underweight: "Under",
        normal: "Normal",
        overweight: "Över",
        obesity: "Fetma",
      },
    },
    bmiCategory: {
      severeUnderweight: "Svår undervikt",
      underweight: "Undervikt",
      normal: "Normalvikt",
      overweight: "Övervikt",
      obesity: "Fetma",
    },
    units: {
      cm: "cm",
      kg: "kg",
      ml: "ml",
      kgPerM2: "kg/m²",
    },
    chart: {
      open: "Tillväxtkurva",
      title: "Tillväxtkurva",
      currentAge: "Aktuell ålder: {{age}}",
      ageYearsMonths: "{{years}} år {{months}} mån",
      sexLabel: "Kön",
      referenceLabel: "Referens",
      viewLabel: "Diagramvy",
      print: "Skriv ut",
      printComingSoon: "Utskrift blir tillgänglig när kurvan är på plats",
      referenceSource: "Referens: {{reference}}",
      sex: {
        female: "Flicka",
        male: "Pojke",
      },
      references: {
        who519: "WHO 5–19",
        who519Short: "WHO 5–19",
        swe81: "Sverige 1981",
        swe81Short: "Sverige 81",
      },
      views: {
        heightWeight: "Längd + vikt",
        bmi: "BMI",
      },
      metrics: {
        height: "Längd",
        weight: "Vikt",
        bmi: "BMI",
      },
      legend: {
        median: "Medel",
        measurements: "Mätningar",
        latest: "Senaste",
        previous: "Tidigare",
        trend: "Förlopp",
      },
      display: {
        title: "Visa",
        currentAge: "Aktuell ålder",
        parentHeight: "Föräldralängd",
        measurementTable: "Mätningstabell",
      },
      parentHeight: {
        title: "Föräldralängd",
        mother: "Biologisk mor",
        father: "Biologisk far",
        midParentalHeight: "Målängd (MPH)",
        sexRequired: "Välj kön för att beräkna målängden",
        localOnlyHint:
          "Förifyllt från senast registrerade mätning. Ändringar här sparas inte.",
      },
      axis: {
        age: "Ålder (år)",
        currentAge: "Ålder",
        midParentalHeight: "MPH {{value}}",
      },
      tooltip: {
        type: "Typ av mätning",
      },
      states: {
        loadError: "Referenskurvorna kunde inte läsas in. Försök igen.",
        selectSex: "Välj kön för att visa rätt referenskurvor.",
        missingReference: "Referenskurva saknas för vald kombination.",
        missingMetricReference:
          "Referenskurva för {{metric}} saknas i {{reference}}.",
        noMeasurements: "Inga mätningar registrerade för eleven.",
        noBirthDate:
          "Födelsedatum saknas – elevens mätningar kan inte placeras i kurvan.",
      },
      table: {
        age: "Ålder",
        sds: "SDS",
      },
    },
    wizard: {
      title: "Ny tillväxtmätning",
      titleEdit: "Redigera tillväxtmätning",
      previousMeasurements: "Tidigare mätningar",
      previousMeasurementsCount: "{{count}} registrerade",
      noPreviousMeasurements: "Inga tidigare mätningar",
      step1Title: "Grundmätning",
      step2Title: "Pubertet",
      step3Title: "Föräldradata",
      step4Title: "Granska",
      selectDate: "Välj datum",
      measuredAt: "Mätdatum",
      measurementType: "Mätningstyp",
      heightCm: "Längd",
      heightHint: "T.ex. 154.5",
      weightKg: "Vikt",
      weightHint: "T.ex. 43.2",
      pubertyAssessed: "Pubertet bedömd",
      pubertyAssessedHint: "Slå på om pubertetsbedömning genomförts",
      tannerBreastStage: "Tanner-stadium bröst",
      tannerGenitalStage: "Tanner-stadium genitalier",
      tannerPubicHairStage: "Tanner-stadium pubesbehåring",
      testicularVolumeLeftMl: "Testikelvolym vänster (ml)",
      testicularVolumeRightMl: "Testikelvolym höger (ml)",
      menarcheStatus: "Menarkestatus",
      menarcheDate: "Menarkedatum",
      biologicalMotherHeightCm: "Biologisk mors längd (cm)",
      motherHeightHint: "T.ex. 162.0",
      biologicalFatherHeightCm: "Biologisk fars längd (cm)",
      fatherHeightHint: "T.ex. 178.0",
      midParentalHeightPreview: "Beräknad målängd (MPH)",
      midParentalHeightFormula:
        "Baserat på biologiska föräldrars längd och barnets kön",
      midParentalHeightEmpty:
        "Fyll i båda föräldrarnas längd för att beräkna målängden",
      midParentalHeightGenderRequired:
        "Målängden kan bara beräknas när elevens kön är angett som Man eller Kvinna. Uppdatera det i elevens profil.",
      midParentalHeightProtected:
        "Elevens uppgifter är skyddade. Visa eleven i profilen för att beräkna målängden.",
      note: "Klinisk anteckning",
      notePlaceholder: "Lägg till en anteckning...",
      saveDraft: "Spara utkast",
      saveAndSign: "Spara och signera",
      savedDraftSuccess: "Utkastet sparades.",
      signedSuccess: "Mätningen signerades.",
      lockedTitle: "Mätningen är signerad",
      lockedDescription:
        "Den här mätningen är signerad och kan inte ändras. Lås upp den för att kunna redigera.",
      unlockToEdit: "Lås upp för att redigera",
      discardTitle: "Ignorera ändringar?",
      discardMessage:
        "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
      continueEditing: "Fortsätt redigera",
      discardChanges: "Ignorera ändringar",
    },
    menarcheStatus: {
      notAssessed: "Ej bedömd",
      no: "Nej",
      yes: "Ja",
      unknown: "Okänd",
    },
    validation: {
      heightRange: "Ange en längd mellan 30 och 250 cm",
      weightRange: "Ange en vikt mellan 1 och 300 kg",
      parentHeightRange: "Ange en längd mellan 70 och 230 cm",
      testicularVolumeRange: "Ange en volym mellan 1 och 100 ml",
    },
    sign: {
      title: "Signera mätning",
      description:
        "Genom att signera bekräftar du att uppgifterna är korrekta. Mätningen låses därefter för redigering.",
      confirmLabel: "Skriv ditt namn för att bekräfta",
      nameMismatch: "Namnet matchar inte ditt kontonamn.",
      cancel: "Avbryt",
      confirm: "Signera",
    },
    unlock: {
      title: "Lås upp mätning",
      description:
        "Ange en anledning till varför denna signerade mätning behöver låsas upp för redigering.",
      signedBy: "Signerad av",
      reasonLabel: "Anledning",
      reasonPlaceholder: "Beskriv varför mätningen behöver låsas upp...",
      cancel: "Avbryt",
      confirm: "Lås upp",
    },
    detail: {
      title: "Tillväxtmätning",
      edit: "Redigera",
      sign: "Signera",
      unlock: "Lås upp",
      export: "Exportera",
      measuredBy: "Mätt av",
      midParentalHeight: "Beräknad målängd (MPH)",
      eventLog: "Händelselogg",
      changelog: "Ändringshistorik",
      snapshotPreview: "Ögonblicksbild",
      deleteConfirmTitle: "Ta bort mätning?",
      deleteConfirmMessage:
        "Är du säker på att du vill ta bort denna mätning? Åtgärden kan inte ångras.",
      deletedSuccess: "Mätningen togs bort.",
      exportedSuccess: "Mätningen exporterades.",
      unlockedSuccess: "Mätningen låstes upp.",
    },
    eventLog: {
      created: "Mätning skapad",
      updated_draft: "Utkast uppdaterat",
      signed: "Mätning signerad",
      unlocked: "Mätning upplåst",
      exported: "Mätning exporterad",
      removed: "Mätning borttagen",
    },
  },
  visionScreening: {
    sectionTitle: "Synscreening",
    registerScreening: "Ny synscreening",
    noScreenings: "Inga synscreeningar har registrerats än.",
    table: {
      date: "Datum",
      right: "Höger",
      left: "Vänster",
      binocular: "Binokulärt",
      systemResult: "Systemresultat",
      finalAssessment: "Bedömning",
      status: "Status",
    },
    contactType: {
      health_visit: "Hälsobesök",
      reception_visit: "Mottagningsbesök",
      follow_up: "Uppföljning",
      other: "Annat",
    },
    correction: {
      none: "Ingen",
      glasses: "Glasögon",
      contact_lenses: "Linser",
      unknown: "Okänd",
      not_tested: "Ej testad",
    },
    testMethod: {
      km_chart: "KM-tavla",
      hvot_chart: "HVOT-tavla",
      evnd_chart: "EVND-tavla",
      snellen_rows: "Snellen-rader",
      letter_rows: "Bokstavsrader",
      lea_symbols: "LEA symboler",
      other: "Annat",
    },
    eye: {
      right: "Höger öga",
      left: "Vänster öga",
    },
    acuityCategory: {
      excellent: "Utmärkt",
      acceptable: "Godkänd",
      belowThreshold: "Under gräns",
    },
    resultStatus: {
      normal: "Normal",
      incomplete: "Ofullständig",
      needs_retest: "Omtest rekommenderas",
      follow_up_needed: "Uppföljning behövs",
      refer_optician: "Remiss till optiker",
      refer_eye_clinic: "Remiss till ögonklinik",
    },
    finalAssessment: {
      normal: "Normal",
      retest: "Omtest",
      follow_up_needed: "Uppföljning behövs",
      refer_optician: "Remiss till optiker",
      refer_eye_clinic: "Remiss till ögonklinik",
      primary_care: "Vårdcentral",
      no_action: "Ingen åtgärd",
    },
    referralTarget: {
      eye_clinic: "ögonklinik",
      optician: "optiker",
    },
    units: {
      m: "m",
    },
    form: {
      title: "Ny synscreening",
      titleEdit: "Redigera synscreening",
      selectDate: "Välj datum",
      selectPlaceholder: "Välj...",
      screenedAt: "Datum",
      contactType: "Besökstyp",
      contactTypeRequired: "Besökstyp är obligatoriskt.",
      screeningDistanceMeters: "Testavstånd (m)",
      screeningDistancePlaceholder: "T.ex. 5",
      screeningDistanceRange: "Ange ett testavstånd mellan 0,5 och 20 m",
      screeningCompleted: "Genomförandestatus",
      completed: "Screening genomförd",
      notCompleted: "Ej genomförd",
      reasonNotCompletedPlaceholder:
        "Ange anledning till att screeningen inte kunde genomföras...",
      observations: "Observationer",
      symptomsReported: "Symtom rapporterade",
      symptomsNotePlaceholder: "Beskriv rapporterade symtom...",
      squintOrStrabismusObserved: "Skelning observerad",
      previousEyeCareContact: "Tidigare kontakt med ögonvård",
      note: "Anteckning",
      notePlaceholder: "Lägg till en anteckning...",
      quickActions: "Snabbåtgärder",
      quickActionNormal: "Synscreening u.a.",
      quickActionBothToOne: "Sätt höger + vänster → 1.0",
      autoSummaryTitle: "Automatisk sammanfattning",
      ageReferralHint: "Ålder {{age}} år (≥{{ageThreshold}} år) → {{target}}",
      testMethod: "Testmetod",
      testMethodRequired: "Testmetod är obligatoriskt.",
      testMethodOtherPlaceholder: "Ange testmetod",
      rightEye: "Höger öga",
      leftEye: "Vänster öga",
      binocular: "Binokulär",
      correction: "Korrektion",
      visualAcuity: "Synskärpa (decimal)",
      thresholdCaption: "Gräns: {{threshold}}",
      fieldLabel: {
        rightEyeVisualAcuity: "Höger öga",
        leftEyeVisualAcuity: "Vänster öga",
      },
      saveDraft: "Spara utkast",
      saveAndSign: "Spara och signera",
      savedDraftSuccess: "Utkastet sparades.",
      signedSuccess: "Synscreeningen signerades.",
      lockedTitle: "Synscreeningen är signerad",
      lockedDescription:
        "Den här synscreeningen är signerad och kan inte ändras. Lås upp den för att kunna redigera.",
      unlockToEdit: "Lås upp för att redigera",
      discardTitle: "Ignorera ändringar?",
      discardMessage:
        "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
      continueEditing: "Fortsätt redigera",
      discardChanges: "Ignorera ändringar",
    },
    summary: {
      notCompleted: "Screeningen genomfördes inte.",
      missingValues: "Saknade värden: {{fields}}.",
      normal: "Höger och vänster öga är minst {{threshold}}.",
      symptomsFlag:
        "Synskärpan är inom godkänt intervall, men symtom/observationer har dokumenterats. Uppföljning av sjuksköterska rekommenderas.",
      belowThreshold: "Värden under gränsen ({{threshold}}): {{eyes}}.",
      interocularDifference:
        "Skillnad mellan ögonen: {{diff}} (gräns {{maxInterocularDifference}}). Höger: {{right}}, vänster: {{left}}.",
      referralSuggestion:
        "Baserat på ålder och resultat: överväg {{assessment}} enligt lokal rutin.",
    },
    sign: {
      title: "Signera synscreening",
      description:
        "Genom att signera bekräftar du att uppgifterna är korrekta. Synscreeningen låses därefter för redigering.",
      confirmLabel: "Skriv ditt namn för att bekräfta",
      nameMismatch: "Namnet matchar inte ditt kontonamn.",
      cancel: "Avbryt",
      confirm: "Signera",
    },
    unlock: {
      title: "Lås upp synscreening",
      description:
        "Ange en anledning till varför denna signerade synscreening behöver låsas upp för redigering.",
      signedBy: "Signerad av",
      reasonLabel: "Anledning",
      reasonPlaceholder: "Beskriv varför synscreeningen behöver låsas upp...",
      cancel: "Avbryt",
      confirm: "Lås upp",
    },
    detail: {
      title: "Synscreening",
      edit: "Redigera",
      sign: "Signera",
      unlock: "Lås upp",
      screenedBy: "Utförd av",
      reasonNotCompleted: "Anledning till att screeningen inte genomfördes",
      testMethodOther: "Annan testmetod",
      autoSummaryTitle: "Automatisk screeningssammanfattning",
      finalAssessmentTitle: "Sjuksköterskans bedömning",
      finalAssessmentNotApplicable:
        "Kan inte bedömas eftersom screeningen inte genomfördes.",
      eventLog: "Händelselogg",
      changelog: "Ändringshistorik",
      deleteConfirmTitle: "Ta bort synscreening?",
      deleteConfirmMessage:
        "Är du säker på att du vill ta bort denna synscreening? Åtgärden kan inte ångras.",
      deletedSuccess: "Synscreeningen togs bort.",
      unlockedSuccess: "Synscreeningen låstes upp.",
      finalAssessmentUpdatedSuccess: "Bedömningen uppdaterades.",
    },
    eventLog: {
      created: "Synscreening skapad",
      updated_draft: "Utkast uppdaterat",
      signed: "Synscreening signerad",
      unlocked: "Synscreening upplåst",
      exported: "Synscreening exporterad",
      removed: "Synscreening borttagen",
      final_assessment_updated: "Bedömning uppdaterad",
    },
  },
  hearingScreening: {
    sectionTitle: "Hörselscreening",
    registerScreening: "Ny hörselscreening",
    noScreenings: "Inga hörselscreeningar har registrerats än.",
    table: {
      date: "Datum",
      systemResult: "Systemresultat",
      finalAssessment: "Bedömning",
      status: "Status",
      performedBy: "Utförd av",
    },
    contactType: {
      health_visit: "Hälsobesök",
      reception_visit: "Mottagningsbesök",
      follow_up: "Uppföljning",
      other: "Annat",
    },
    screeningType: {
      routine: "Rutinkontroll",
      follow_up: "Uppföljning",
      extra_check: "Extra kontroll",
      imported: "Importerad",
    },
    ear: {
      right: "Höger öra",
      left: "Vänster öra",
      rightLower: "höger öra",
      leftLower: "vänster öra",
    },
    resultStatus: {
      normal: "Normal",
      incomplete: "Ofullständig",
      minor_deviation: "Mindre avvikelse",
      needs_retest: "Omtest rekommenderas",
      follow_up_needed: "Uppföljning behövs",
      referred: "Remitterad",
    },
    finalAssessment: {
      normal: "Normal",
      needs_retest: "Omtest",
      follow_up_needed: "Uppföljning behövs",
      referred: "Remitterad",
      no_action: "Ingen åtgärd",
    },
    units: {
      hz: "Hz",
      dbHl: "dB HL",
    },
    audiogram: {
      rightEar: "Höger öra · O",
      leftEar: "Vänster öra · X",
      rightEarShort: "H",
      leftEarShort: "V",
      thresholdLine: "{{threshold}} dB gräns",
      aboveThreshold: "Över screeninggräns",
      frequencyAxis: "Frekvens (Hz)",
    },
    form: {
      title: "Ny hörselscreening",
      titleEdit: "Redigera hörselscreening",
      selectDate: "Välj datum",
      selectPlaceholder: "Välj...",
      screeningDetailsTitle: "Screeninguppgifter",
      screenedAt: "Datum",
      screeningThresholdDb: "Screeninggräns",
      contactType: "Besökstyp",
      screeningType: "Screeningtyp",
      note: "Anteckning",
      notePlaceholder: "Fritext...",
      frequency: "Frekvens (Hz)",
      optional: "valfri",
      resultFieldLabel: "{{ear}}, {{frequency}} Hz, dB HL",
      showAdditionalFrequencies: "Visa fler frekvenser: {{list}}",
      hideAdditionalFrequencies: "Dölj fler frekvenser",
      additionalResultsHiddenNote_one:
        "{{count}} ytterligare resultat registrerat",
      additionalResultsHiddenNote_other:
        "{{count}} ytterligare resultat registrerade",
      completionCount:
        "{{recorded}} av {{total}} obligatoriska resultat registrerade",
      completionHintEmpty: "Ange resultat för båda öronen.",
      completionHintComplete: "Alla obligatoriska resultat är registrerade",
      viewMissing: "Visa saknade",
      hideMissing: "Dölj saknade",
      missingListTitle: "Saknade obligatoriska resultat",
      dateRequired: "Välj ett screeningdatum.",
      thresholdRequired: "Screeninggräns är obligatoriskt.",
      contactTypeRequired: "Välj en besökstyp.",
      screeningTypeRequired: "Välj en screeningtyp.",
      missingResultFor: "Ange ett resultat för {{ear}} vid {{frequency}} Hz.",
      valueRangeError: "Värdet måste vara mellan {{min}} och {{max}} dB HL.",
      errorSummaryTitle_one: "Åtgärda följande fel innan du kan signera:",
      errorSummaryTitle_other:
        "Åtgärda följande {{count}} fel innan du kan signera:",
      quickActions: "Snabbåtgärder",
      quickActionFillEmpty: "Fyll i tomma resultat med {{threshold}} dB HL",
      quickActionRecordNormal:
        "Registrera normala resultat för alla obligatoriska frekvenser ({{threshold}} dB HL)",
      quickActionOverwriteAll: "Skriv över alla med {{threshold}} dB HL",
      quickActionOverwriteConfirmTitle: "Skriv över befintliga resultat?",
      quickActionOverwriteConfirmMessage:
        "Detta sätter {{count}} fält över {{frequencyCount}} frekvenser till {{threshold}} dB HL för båda öronen, vilket ersätter {{existingCount}} befintliga resultat. Du kan ångra direkt efteråt.",
      quickActionRecordNormalConfirmTitle:
        "Ersätt befintliga obligatoriska resultat?",
      quickActionRecordNormalConfirmMessage:
        "Detta sätter alla {{count}} obligatoriska resultat till {{threshold}} dB HL för båda öronen, vilket ersätter {{existingCount}} befintliga resultat. Bedömningsfältet ändras inte. Du kan ångra direkt efteråt.",
      quickActionConfirmCta: "Ja, sätt värden",
      bulkEditAppliedMessage_one:
        "Satte {{count}} resultat till {{threshold}} dB HL.",
      bulkEditAppliedMessage_other:
        "Satte {{count}} resultat till {{threshold}} dB HL.",
      bulkEditNothingToFill: "Alla synliga resultat har redan ett värde.",
      undo: "Ångra",
      undoAppliedMessage_one: "Återställde {{count}} resultat.",
      undoAppliedMessage_other: "Återställde {{count}} resultat.",
      autoSummaryTitle: "Automatisk sammanfattning",
      finalAssessment: "Bedömning (sjuksköterska)",
      tabValues: "Värden",
      tabAudiogram: "Audiogram",
      saveDraft: "Spara utkast",
      reviewAndSign: "Granska och signera",
      reviewIntro:
        "Kontrollera uppgifterna nedan och signera sedan för att låsa denna screening för redigering.",
      reviewBackToEdit: "Tillbaka till redigering",
      reviewSignButton: "Signera screening",
      footerStatusSaving: "Sparar…",
      footerStatusUnsaved: "Osparade ändringar",
      savedDraftSuccess: "Utkastet sparades.",
      signedSuccess: "Hörselscreeningen signerades.",
      lockedTitle: "Hörselscreeningen är signerad",
      lockedDescription:
        "Den här hörselscreeningen är signerad och kan inte ändras. Lås upp den för att kunna redigera.",
      unlockToEdit: "Lås upp för att redigera",
      discardTitle: "Ignorera ändringar?",
      discardMessage:
        "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
      continueEditing: "Fortsätt redigera",
      discardChanges: "Ignorera ändringar",
    },
    summary: {
      normal:
        "Alla obligatoriska frekvenser hördes vid {{threshold}} dB HL eller bättre.",
      missingIntro: "Saknade obligatoriska värden:",
      minorDeviationIntro:
        "En frekvens var över screeninggränsen men inom den tillåtna lokala undantagsregeln.",
      needsRetestIntro:
        "Följande värden är över den konfigurerade screeninggränsen:",
      thresholdLine: "Konfigurerad gräns: {{threshold}} dB HL",
      retestSuggestion: "Överväg omtest eller uppföljning enligt lokal rutin.",
    },
    sign: {
      title: "Signera hörselscreening",
      description:
        "Genom att signera bekräftar du att uppgifterna är korrekta. Hörselscreeningen låses därefter för redigering.",
      confirmLabel: "Skriv ditt namn för att bekräfta",
      nameMismatch: "Namnet matchar inte ditt kontonamn.",
      cancel: "Avbryt",
      confirm: "Signera",
    },
    unlock: {
      title: "Lås upp hörselscreening",
      description:
        "Ange en anledning till varför denna signerade hörselscreening behöver låsas upp för redigering.",
      signedBy: "Signerad av",
      reasonLabel: "Anledning",
      reasonPlaceholder:
        "Beskriv varför hörselscreeningen behöver låsas upp...",
      cancel: "Avbryt",
      confirm: "Lås upp",
    },
    detail: {
      title: "Hörselscreening",
      edit: "Redigera",
      sign: "Signera",
      unlock: "Lås upp",
      screeningDate: "Screeningdatum",
      screenedBy: "Utförd av",
      threshold: "Gräns",
      audiogram: "Audiogram",
      values: "Hörselvärden",
      autoSummaryTitle: "Automatisk screeningsammanfattning",
      finalAssessmentTitle: "Sjuksköterskans bedömning",
      signed: "Signerad",
      eventLog: "Händelselogg",
      changelog: "Ändringshistorik",
      deleteConfirmTitle: "Ta bort hörselscreening?",
      deleteConfirmMessage:
        "Är du säker på att du vill ta bort denna hörselscreening? Åtgärden kan inte ångras.",
      deletedSuccess: "Hörselscreeningen togs bort.",
      unlockedSuccess: "Hörselscreeningen låstes upp.",
      finalAssessmentUpdatedSuccess: "Bedömningen uppdaterades.",
    },
    eventLog: {
      created: "Hörselscreening skapad",
      updated_draft: "Utkast uppdaterat",
      signed: "Hörselscreening signerad",
      unlocked: "Hörselscreening upplåst",
      exported: "Hörselscreening exporterad",
      removed: "Hörselscreening borttagen",
      final_assessment_updated: "Bedömning uppdaterad",
    },
  },
  studentMarker: {
    bannerTitle: "Markeringar",
    addMarker: "Lägg till markering",
    archiveMarker: "Arkivera markering",
    archiveTitle: "Arkivera markering?",
    archiveMessage:
      'Att arkivera "{{title}}" tar bort den från profilen. Den finns kvar i händelseloggen och kan återställas senare.',
    archiveConfirm: "Arkivera",
    archiveSuccess: "Markeringen har arkiverats.",
    noEndDate: "Inget slutdatum",
    protectedLockPrompt:
      "Denna elevs profil är skyddad. Klicka för att visa markeringar.",
    visibleTo: "Synlig för",
    visibleToHint:
      "Endast användare med vald journalåtkomst kan se denna markering.",
    visibleToRestrictedCount_one: "{{count}} begränsad journal",
    visibleToRestrictedCount_other: "{{count}} begränsade journaler",
    form: {
      titleCreate: "Lägg till markering",
      subtitle: "Visas högst upp på elevens profil för behöriga användare",
      titleLabel: "Titel",
      titlePlaceholder: "T.ex. Jordnötsallergi, Epipen behövs...",
      descriptionLabel: "Beskrivning",
      descriptionOptionalLabel: "Beskrivning (valfri)",
      descriptionPlaceholder: "Ytterligare information...",
      typeLabel: "Typ",
      severityLabel: "Allvarlighetsgrad",
      advancedSectionTitle: "Avancerat — giltighetstid",
      validFromLabel: "Giltig från",
      validUntilLabel: "Giltig till",
      sourceTypeLabel: "Källa",
      cancel: "Avbryt",
      save: "Spara markering",
      discardTitle: "Kasta ändringar?",
      discardMessage:
        "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
      continueEditing: "Fortsätt redigera",
      discardChanges: "Kasta ändringar",
    },
    type: {
      allergy: "Allergi",
      hypersensitivity: "Överkänslighet",
      medical_warning: "Medicinsk varning",
      information: "Information",
    },
    severity: {
      low: "Låg",
      high: "Hög",
    },
    priority: {
      low: "Låg prioritet",
      high: "Hög prioritet",
    },
    sourceType: {
      manual: "Manuell",
      imported: "Importerad",
      other: "Annat",
    },
    validation: {
      journalTypeIdsRequired: "Välj minst en journalmapp.",
      validUntilBeforeValidFrom:
        '"Giltig till" måste vara samma dag som eller senare än "Giltig från".',
      titleMaxLength: "Max 250 tecken är tillåtet.",
    },
  },
  customReport: {
    heading: "Du har blivit taggad i en anpassad rapport",
    message: '{{taggerName}} taggade dig i "{{reportName}}"',
  },
  referral: {
    common: {
      select: "Välj...",
      back: "Tillbaka",
      next: "Nästa",
      cancel: "Avbryt",
      save: "Spara",
      edit: "Redigera",
      remove: "Ta bort",
      optional: "valfri",
    },
    status: {
      draft: "Utkast",
      signed: "Signerad",
      sent: "Skickad",
      response_received: "Svar mottaget",
      closed: "Avslutad",
      cancelled: "Makulerad",
      deleted: "Borttagen",
    },
    sentMethods: {
      post: "Post",
      handed_over: "Överlämnad",
      secure_email: "Säker e-post",
      other: "Annat",
    },
    recipientTypes: {
      bup: "BUP",
      health_center: "Vårdcentral",
      specialist_clinic: "Specialistmottagning",
      speech_therapy: "Logopedi",
      other: "Annat",
    },
    list: {
      title: "Remisser",
      totalCount: "{{count}} totalt",
      subtitle: "Alla remisser – utkast, signerade, skickade och besvarade",
      recipients: "Mottagare",
      create: "Skapa remiss",
      all: "Alla",
      moreFilters: "Fler filter",
      allSenders: "Alla avsändare",
      allCreators: "Alla",
      fromDate: "Från",
      toDate: "Till",
      clearFilters: "Rensa filter",
      studentAttributes: "Elevattribut",
      searchPlaceholder: "Sök elev, mottagare...",
      stats: {
        total: "Totalt",
        draft: "Utkast",
        active: "Aktiva",
        awaiting: "Väntar svar",
      },
      responseFilter: {
        all: "Alla svar",
        received: "Svar mottaget",
        missing: "Saknar svar",
      },
      columns: {
        student: "Elev",
        recipient: "Mottagare",
        requestedExamination: "Önskad undersökning",
        sender: "Avsändare",
        status: "Status",
        createdAt: "Skapad",
        createdBy: "Skapad av",
      },
      emptyTitle: "Inga remisser ännu",
      emptySubtitle:
        "Skapa en remiss för att skicka en elev vidare till t.ex. BUP, vårdcentral eller specialistmottagning.",
      noMatchTitle: "Inga remisser matchar",
      noMatchSubtitle: "Prova att ändra filter eller sökning.",
    },
    wizard: {
      title: "Skapa remiss",
      editTitle: "Redigera remiss",
      stepOf: "Steg {{step}} av {{total}}",
      steps: {
        student: "Elev",
        recipient: "Mottagare",
        content: "Innehåll",
        sender: "Avsändare",
      },
      studentHint: "Välj den elev remissen gäller. En remiss avser en elev.",
      studentLocked: "Eleven kan inte ändras på en befintlig remiss.",
      studentFromProcess: "Remissen skapas för eleven i den här processen.",
      searchStudent: "Sök elev...",
      noStudents: "Inga elever hittades.",
      savedRecipient: "Sparad mottagare",
      manualRecipient: "Ange manuellt",
      noSavedRecipients: "Det finns inga sparade mottagare ännu.",
      saveAsRecipient: "Spara som mottagare för framtida remisser",
      consentLabel: "Samtycke från vårdnadshavare/elev är bekräftat",
      senderHint:
        "Välj vem som står som avsändare på remissen. Inloggad användare signerar.",
      staffFallbackRole: "Elevhälsopersonal",
      discardTitle: "Ignorera ändringar?",
      discardMessage:
        "Du har osparade ändringar. Är du säker på att du vill lämna utan att spara?",
      continueEditing: "Fortsätt redigera",
      discardChanges: "Ignorera ändringar",
    },
    validation: {
      tooLong: "Texten är för lång",
      nameTooLong: "Namnet är för långt (max 100 tecken)",
    },
    fields: {
      recipientName: "Namn",
      recipientType: "Mottagartyp",
      organization: "Organisation",
      department: "Avdelning",
      phone: "Telefon",
      email: "E-post",
      address: "Adress",
      postalCode: "Postnummer",
      city: "Ort",
      country: "Land",
      notes: "Anteckningar",
      requestedExamination: "Önskad undersökning",
      referralReason: "Frågeställning",
      referralText: "Remisstext",
      background: "Bakgrund",
      previousActions: "Tidigare insatser",
      consent: "Samtycke",
      internalNote: "Intern anteckning",
      attachment: "Bilaga",
      sentAt: "Skickad datum",
      sentMethod: "Sätt",
      note: "Anteckning",
      uploadResponse: "Ladda upp svar",
      responseReceivedAt: "Svar mottaget datum",
      responseSummary: "Sammanfattning av svaret",
      closeNote: "Avslutningsanteckning",
      reason: "Anledning",
    },
    placeholders: {
      recipientName: "Mottagarens namn",
      organization: "T.ex. Region Skåne",
      department: "T.ex. BUP",
      phone: "Telefon",
      email: "namn@exempel.se",
      address: "Gata och nummer",
      postalCode: "XXX XX",
      city: "Ort",
      requestedExamination: "T.ex. ADHD-utredning, logopedbedömning",
      referralReason: "Vad ska mottagaren bedöma?",
      referralText: "Remissens huvudinnehåll",
      background: "Relevant kontext",
      previousActions: "Vad skolan/EMI redan gjort",
      consentNote: "T.ex. vårdnadshavare samtycker via signerat samtycke",
      internalNote: "Syns endast internt, skrivs inte ut",
      responseSummary:
        "T.ex. BUP har mottagit remissen och kallar vårdnadshavare.",
    },
    actions: {
      saveDraft: "Spara utkast",
      saveAndSign: "Spara och signera",
      sign: "Signera",
      edit: "Redigera",
      cancel: "Avbryt remiss",
      delete: "Ta bort utkast",
      unlock: "Lås upp",
      downloadPdf: "Ladda ner PDF",
      markSent: "Markera som skickad",
      uploadResponse: "Ladda upp remissvar",
      registerResponse: "Registrera svar utan fil",
      close: "Avsluta remiss",
    },
    confirm: {
      signTitle: "Signera remiss",
      signMessage:
        "Du är på väg att signera denna remiss. Efter signering låses den för redigering. Vill du fortsätta?",
      signNameLabel: "Skriv ditt namn för att bekräfta",
      signNameMismatch: "Namnet matchar inte ditt kontonamn.",
      unlockTitle: "Lås upp remiss",
      unlockMessage:
        "Remissen återgår till utkast så att den kan redigeras. Upplåsningen loggas med anledning.",
      cancelTitle: "Avbryt remiss",
      cancelMessage:
        "Remissen makuleras och kan inte skickas. Åtgärden loggas.",
      deleteTitle: "Ta bort utkast",
      deleteMessage: "Utkastet tas bort. Historiken sparas i arkivet.",
      closeTitle: "Avsluta remiss",
      closeMessage: "Remissprocessen markeras som avslutad.",
      closeWithoutResponseMessage:
        "Inget remissvar är registrerat. Ange varför remissen avslutas utan svar.",
    },
    markSent: {
      title: "Markera som skickad",
      subtitle: "Ange när och hur remissen skickades.",
    },
    response: {
      uploadTitle: "Ladda upp remissvar",
      uploadSubtitle: "Ladda upp det mottagna svaret och ange när det kom.",
      registerTitle: "Registrera svar",
      registerSubtitle:
        "Registrera att svar har mottagits utan att ladda upp en fil.",
      submit: "Registrera svar",
      fileTooLarge: "Filen är för stor (max 20 MB).",
    },
    recipients: {
      title: "Sparade mottagare",
      subtitle: "Hantera återkommande remissmottagare",
      add: "Lägg till mottagare",
      addTitle: "Lägg till mottagare",
      editTitle: "Redigera mottagare",
      selectType: "Välj typ",
      empty: "Inga sparade mottagare ännu.",
      removeTitle: "Ta bort mottagare",
      removeMessage:
        "{{name}} tas bort från sparade mottagare. Befintliga remisser påverkas inte.",
    },
    detail: {
      title: "Remiss • {{examination}}",
      to: "Till {{recipient}}",
      notFound: "Remissen hittades inte.",
      draftBanner:
        "Detta är ett utkast och kan redigeras fritt tills det signeras.",
      recipient: "Mottagare",
      sender: "Avsändare",
      createdBy: "Skapad av",
      created: "Skapad",
      signed: "Signerad",
      sent: "Skickad",
      responseReceived: "Svar mottaget",
      closed: "Avslutad",
      actions: "Åtgärder",
      history: "Historik",
      noHistory: "Ingen historik ännu.",
      system: "System",
      consentConfirmed: "Samtycke bekräftat",
      consentNotConfirmed: "Ej bekräftat",
      response: "Remissvar",
      responseReceivedOn: "Mottaget {{date}}",
      documents: "Dokument",
      documentAttachment: "Bilaga",
      documentResponse: "Remissvar",
    },
    events: {
      created: "Skapad",
      updated_draft: "Utkast uppdaterat",
      signed: "Signerad",
      unlocked: "Upplåst",
      marked_sent: "Markerad som skickad",
      response_uploaded: "Svar mottaget och uppladdat",
      response_registered: "Svar mottaget och registrerat",
      closed: "Avslutad",
      cancelled: "Makulerad",
      deleted: "Borttagen",
      exported: "PDF nedladdad",
    },
    notify: {
      draftSaved: "Utkastet sparades",
      signed: "Remissen signerades",
      attachmentFailed:
        "Remissen sparades men bilagan kunde inte laddas upp. Redigera utkastet för att försöka igen.",
      unlocked: "Remissen låstes upp",
      cancelled: "Remissen makulerades",
      deleted: "Utkastet togs bort",
      markedSent: "Remissen markerades som skickad",
      responseRegistered: "Remissvaret registrerades",
      closed: "Remissen avslutades",
      recipientSaved: "Mottagaren sparades",
      recipientRemoved: "Mottagaren togs bort",
    },
    errors: {
      generic: "Något gick fel. Försök igen.",
      REFERRAL_PERMISSION_DENIED: "Du saknar behörighet för remisser.",
      REFERRAL_NOT_FOUND: "Remissen hittades inte.",
      REFERRAL_RECIPIENT_NOT_FOUND: "Mottagaren hittades inte.",
      REFERRAL_STUDENT_NOT_FOUND: "Eleven hittades inte.",
      REFERRAL_SENDER_NOT_FOUND: "Avsändaren hittades inte.",
      REFERRAL_INVALID_STATUS:
        "Åtgärden är inte tillåten i remissens nuvarande status.",
      REFERRAL_NOT_EDITABLE: "Endast utkast kan redigeras.",
      REFERRAL_MISSING_REQUIRED_FIELDS: "Obligatoriska fält saknas.",
      REFERRAL_REASON_REQUIRED: "Ange en anledning.",
      REFERRAL_RESPONSE_SUMMARY_REQUIRED: "Ange en sammanfattning av svaret.",
      REFERRAL_CLOSE_NOTE_REQUIRED: "Ange varför remissen avslutas utan svar.",
    },
    pdf: {
      heading: "Remiss",
      date: "Datum",
      referralId: "Remiss-ID",
      student: "Elev",
      recipient: "Mottagare",
      sender: "Avsändare",
      name: "Namn",
      personalIdentity: "Personnummer",
      birthday: "Födelsedatum",
      class: "Klass",
      school: "Skola",
      organization: "Organisation",
      department: "Avdelning",
      address: "Adress",
      phone: "Telefon",
      email: "E-post",
      role: "Titel/roll",
      signed: "Signerad",
      attachments: "Bilagor",
      content: "Remissinnehåll",
      summary: "Sammanfattning",
      generatedBy: "Genererad av:",
    },
  },
};

export default sv;
